import React, { useEffect, useMemo, useState } from "react";
import {
  Box,
  Button,
  Card,
  CircularProgress,
  Grid,
  Typography,
  useMediaQuery,
  useTheme,
   Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
    Dialog,
    FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormControlLabel,
  DialogActions, DialogContent,  DialogContentText, DialogTitle, CardContent,
  Autocomplete, Paper, IconButton, Menu,
  FormGroup, Checkbox, Popover, Tooltip, Chip, InputAdornment, Divider
} from "@mui/material";
import { useNavigate, useParams, Link } from "react-router-dom";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { useStyles } from "../../../theme/appStyles";
import useDebounce from "../../../Components/SearchDebonce/useDebounce";
import {
  useGetCategoryQuery,
  useGetPrinterQuery,
  useGetProductBrandQuery,
  useGetEventQuery,
  useGetVariantQuery,
  useGetProductTagQuery,
  useDeleteVariantMutation,
  useGetModifierGroupQuery,
  useGetModifierGrpQuery,
  useGetModifierQuery,
  useGetProductCategoryQuery,
  useGetAllMainCategoryQuery,
  useGetSubCategoryByArrayQuery,
  useGetSerializedItemQuery,
  useGetSoldQuery,
  useGetInventoryQuery,
  useGetAllInvoiceQuery
} from "../../../Api/attoDeskApi";
import {
  ICategory,
  IPrinter,
  IEventPopUP,
  IProductBrand,
  IProductTag,
  IProductPopUP,
  IVariantPopUP,
  IModifierGroupPopUp,
  IModifierGrpPopUp,
  IModifierPopUp,
  ModifierInfo,
  ProductInfo,
  ISerializedItem,
  ISold,
  IProductInventory,
  IInvoice
} from "../../../Api/Interface/api.interface";
import { SizeOfLevelType } from "../../../Core/Enum/enum";
import CheckRoundedIcon from "@mui/icons-material/CheckRounded";
import ClearRoundedIcon from "@mui/icons-material/ClearRounded";
import Barcode from "react-barcode";
import placeholderImage from '../../../Images/fav.png';
import DeleteOutlineSharpIcon from "@mui/icons-material/DeleteOutlineSharp";
import EditSharpIcon from "@mui/icons-material/EditSharp";
import EditVariantPopUp from "../Components/EditVariantPopUp";
import CreateVariantPopUp from "../Components/CreateVariantPopUp";
import DeletePopup from "../../../Components/Delete/DeletePopup";
import { useNotifier } from "../../../Core/Notifier";
import CustomCheckbox from "../../../Components/Checkbox.tsx";
import { Dayjs } from "dayjs";
import Switch, { SwitchProps } from "@mui/material/Switch";
import axios from "axios";
import VisibilitySharpIcon from "@mui/icons-material/VisibilitySharp";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import Inventory2Icon from "@mui/icons-material/Inventory2";
import CategoryIcon from "@mui/icons-material/Category";
import GroupsIcon from "@mui/icons-material/Groups";
import VisibilityIcon from "@mui/icons-material/Visibility";
import LoopIcon from "@mui/icons-material/Loop";
import PointOfSaleIcon from '@mui/icons-material/PointOfSale'; 
import { styled, Theme, CSSObject } from "@mui/material/styles";
import LinkIcon from '@mui/icons-material/Link';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { string } from "yup";
import moment from "moment";
import {
  DragDropContext,
  Droppable,
  Draggable
} from "@hello-pangea/dnd";


import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import Pagination from "../../../Components/Pagination";
import dayjs from "dayjs";
import { CiSearch } from "react-icons/ci";
import CloseIcon from '@mui/icons-material/Close';
import { Timeline, TimelineItem, TimelineSeparator, TimelineConnector, TimelineContent, TimelineDot, TimelineOppositeContent } from '@mui/lab';
import MoreVertIcon from "@mui/icons-material/MoreVert";
import LanguageIcon from '@mui/icons-material/Language';
import RestaurantIcon from "@mui/icons-material/Restaurant";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import { WorkOrderStatus } from "../../../Core/Enum/enum";
import DescriptionIcon from '@mui/icons-material/Description';
import QrCodeScannerIcon from "@mui/icons-material/QrCodeScanner";


const getStatusLabel = (statusCode: number): string => {
  switch (statusCode) {
    case WorkOrderStatus.Paid:
      return "Paid";
    case WorkOrderStatus.Cancel:
      return "Canceled";
    case WorkOrderStatus.Pending:
      return "Pending";
      case WorkOrderStatus.Initiated:
        return "Initiated";
    default:
      return "Unknown Status";
  }
};

const getStatusColor = (statusCode: number): string => {
  switch (statusCode) {
    case WorkOrderStatus.Paid:
      return "#4caf50";
    case WorkOrderStatus.Cancel:
      return "#f44336";
    case WorkOrderStatus.Pending:
      return "#ff9800";
        case WorkOrderStatus.Initiated:
  return "#2196f3"
    default:
      return "#9e9e9e";
  }
};

interface ModifierGroupSelection {
  id?: number;
  modifierGroupId: number;
  required: boolean;
  minimum: number;
  maximum: number;
  order: number | null;
  modifiers?:ModifierInfo[];
}

interface ModifierGrpSelection {
  id?: number;
  modifierGroupId: number;
  modifierGroupName: string;
  minimum: number | string;
  maximum: number | string;
  modifiers?:ProductInfo[];
  order? : number;
}

type StockHistoryItem = {
  date: string;
  type: string; // 'Purchase' or 'Sale'
  qty: number;
  balance: number;
  reference: string;
  updated_by?: string | null; 
};


const IOSSwitch = styled((props: SwitchProps) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 62,
  height: 34,
  padding: 0,
  "& .MuiSwitch-switchBase": {
    padding: 0,
    margin: 2,
    transitionDuration: "300ms",
    "&.Mui-checked": {
      transform: "translateX(28px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        backgroundColor: theme.palette.primary,
        opacity: 1,
        border: 0,
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: 0.5,
      },
    },
    "&.Mui-focusVisible .MuiSwitch-thumb": {
      color: "#33cf4d",
      border: "6px solid #fff",
    },
    "&.Mui-disabled .MuiSwitch-thumb": {
      color:
        theme.palette.mode === "light"
          ? theme.palette.grey[100]
          : theme.palette.grey[600],
    },
    "&.Mui-disabled + .MuiSwitch-track": {
      opacity: theme.palette.mode === "light" ? 0.7 : 0.3,
    },
  },
  "& .MuiSwitch-thumb": {
    boxSizing: "border-box",
    width: 30, // Increased thumb size
    height: 30, // Increased thumb size
  },
  "& .MuiSwitch-track": {
    borderRadius: 34 / 2,
    backgroundColor: theme.palette.mode === "light" ? "#757575" : "#39393D",
    opacity: 1,
    transition: theme.transitions.create(["background-color"], {
      duration: 500,
    }),
    "&::before, &::after": {
      content: '""',
      position: "absolute",
      top: "50%",
      transform: "translateY(-50%)",
      width: 16,
      height: 16,
    },
    "&::before": {
      backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
        theme.palette.getContrastText(theme.palette.primary.main)
      )}" d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"/></svg>')`, // Using SVG path for check
      left: 12,
    },
    "&::after": {
      backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
        theme.palette.getContrastText(theme.palette.primary.main)
      )}" d="M19,13H5V11H19V13Z" /></svg>')`, // Using SVG path for minus
      right: 12,
    },
  },
}));

const isPrinterArray = (data: any): data is IPrinter[] => {
  return (
    Array.isArray(data) &&
    data.every(
      (item) =>
        "id" in item && "printerName" in item && "printerDescription" in item
    )
  );
};




const Index = () => {
  const classes = useStyles();
  const theme = useTheme();
  const navigate = useNavigate();
  const LARAVEL_API_URL = process.env.REACT_APP_LARAVEL_API;
  const [searchQuery, setSearchQuery] = useState("");
  const [searchQueryStock, setSearchQueryStock] = useState("");
  const [searchQuerySale, setSearchQuerySale] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [page, setPage] = useState(0);
  const [selectedModifierGroupIds, setSelectedModifierGroupIds] = useState<number[]>([]);

    const [selectedProduct, setSelectedProduct] = useState<IVariantPopUP | null>(
      null
    );
     const getFormattedDate = (createDate: Dayjs | null): string => {
        return createDate ? createDate.format("YYYY-MM-DD") : "";
      };

     const [selectedProductBrandId, setSelectedProductBrandId] =
        useState<string>("");
      const [selectedProductCategoryId, setSelectedProductCategoryId] =
        useState<string>("");
      const [selectedProductTagIds, setSelectedProductTagIds] = useState<string[]>(
        []
      );
       const [selectedProductViewOnline, setSelectedProductViewOnline] =
          useState<string>("");
        const [startDate, setStartDate] = useState<Dayjs | null>(null);
          const [endDate, setEndDate] = useState<Dayjs | null>(null);
          const startDateAsDate = startDate?.toDate() || null;
          const endDateAsDate = endDate?.toDate() || null;
          const [createDate, setCreateDate] = useState<Dayjs | null>(null);
          const [currentSearchQuery, setCurrentSearchQuery] = useState("");
          const [currentSearchQueryStock, setCurrentSearchQueryStock] = useState("");
          const [currentSearchQuerySale, setCurrentSearchQuerySale] = useState("");
    const [openDialog, setOpenDialog] = useState(false);
    const [openCreateVariantDialog, setOpenCreateVariantDialog] = useState(false);
    const { showErrorMessage, showMessage } = useNotifier();
    const [openDeleteProduct, setOpenDeleteProduct] = useState(false);
    const [productToDelete, setProductToDelete] = useState<IVariantPopUP | null>(
      null
    );
  const [selectedCard, setSelectedCard] = useState<string | null>("Bookings");

  const API_URL = process.env.REACT_APP_API_URL;
const [showModifierGroupPopup, setShowModifierGroupPopup] = useState(false);
const [selectedModifierGroups, setSelectedModifierGroups] = useState<ModifierGroupSelection[]>([]);
const [selectedModifierGroupId, setSelectedModifierGroupId] = useState<number | null>(null);
const [modifierGroupDetails, setModifierGroupDetails] = useState<IModifierGroupPopUp | null>(null);

const [showModifierGrpPopup, setShowModifierGrpPopup] = useState(false);
const [selectedModifierGrps, setSelectedModifierGrps] = useState<ModifierGrpSelection[]>([]);
const [selectedModifierGrpId, setSelectedModifierGrpId] = useState<number | null>(null);
const [modifierGrpDetails, setModifierGrpDetails] = useState<IModifierGrpPopUp[]>([]);

// const [linkedProducts, setLinkedProducts] = useState<IProduct[]>([]);
// const [selectedProducts, setSelectedProducts] = useState<IProduct[]>([]);
const [selectedLinkedProductId, setSelectedLinkProductId] = useState<number | null>(null);
const [showLinkedProductPopup, setShowLinkedProductPopup] = useState(false);
const [productSearchTerm, setProductSearchTerm] = useState("");
const [productSearchResults, setProductSearchResults] = useState([]);
const [selectedModifierGrpIds, setSelectedModifierGrpIds] = useState<string[]>([]);
const [activeGroup, setActiveGroup] = useState<ModifierGrpSelection | null>(null);
const [viewMode, setViewMode] = useState<String>("groupList");
const [selectedRows, setSelectedRows] = useState<Record<number, boolean>>({});


const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
const [openPriceDialog, setOpenPriceDialog] = useState(false);
const [priceValue, setPriceValue] = useState("");
const [searchText, setSearchText] = React.useState("");
const [showOrderPopup, setShowOrderPopup] = React.useState(false);
const [orderList, setOrderList] = useState<IModifierGrpPopUp[]>([]);
// For serialized popup
const [selectedSerialized, setSelectedSerialized] = useState<ISerializedItem | null>(null);
const [openSerialized, setOpenSerialized] = useState(false);
const debouncedSearchQuery = useDebounce(searchQueryStock, 300);
const debouncedSearchQuerySale = useDebounce(searchQuerySale, 300);
const [activeCard, setActiveCard] = useState<"Stock" | "Inv Cost" | "Cost" | "Selling Price" | null>(null);
const [stockHistory, setStockHistory] = useState<StockHistoryItem[]>([]);
const [invCostHistory, setInvCostHistory] = useState<any[]>([]);
const [costHistory, setCostHistory] = useState<any[]>([]);
const [sellingPriceHistory, setSellingPriceHistory] = useState<any[]>([]);
const [loading, setLoading] = useState<boolean>(false);
const [open, setOpen] = useState(false);
const [regPrice, setRegPrice] = useState<number>(0);
const [salePrice, setSalePrice] = useState<number>(0);

const [openManualModal, setOpenManualModal] = useState(false);
const [manualQty, setManualQty] = useState("");
const [manualReason, setManualReason] = useState("");
const [adjustType, setAdjustType] = useState<"add" | "deduct">("add");

const [menuAnchor, setMenuAnchor] = useState<null | HTMLElement>(null);
const [selectedRow, setSelectedRow] = useState<ISerializedItem | null>(null);
const [selectedStatus, setSelectedStatus] = useState<"sold" | "out_of_stock" | "">("");
const [openRemarkDialog, setOpenRemarkDialog] = useState(false);
const [remarks, setRemarks] = useState("");



  const { id: ProductId } = useParams<{ id: string }>();

  useEffect(() => {}, [ProductId]);


  

  const { data, isLoading, isError, refetch: refetchProduct } = useGetEventQuery({
    searchText: "",
    id: String(ProductId),
    productBrandId: null,
    productCategoryId: null,
    productTagIds: null,
    productViewOnline: null,
    createdDateStart: null,
    createdDateEnd: null,
    createdDate: null,
  });
  const { data: allProductsData } = useGetEventQuery({
  searchText: "",
  id: null,
  productBrandId: null,
  productCategoryId: null,
  productTagIds: null,
  productViewOnline: null,
  createdDateStart: null,
  createdDateEnd: null,
  createdDate: null,
});

  const { data: invoiceData, isLoading: invoiceLoading, isError: invoiceError, refetch: invoiceRefetch } = useGetAllInvoiceQuery({
    searchText: currentSearchQuery,
    id: "",
    quoteWorkOrderCustomerId: "",
    quoteWorkOrderCustomerProjectId: "",
    productId: String(ProductId),
  });

  const { data: allSerializedData, refetch } = useGetSerializedItemQuery({
     id: String(ProductId),
    searchText:  currentSearchQueryStock,
});

    useEffect(() => {
      if (debouncedSearchQuery.length >= 4 || debouncedSearchQuery === "") {
        setCurrentSearchQueryStock(debouncedSearchQuery);
      //  refetch();
      }
    }, [debouncedSearchQuery]);

  const { data: soldData } = useGetSoldQuery({
     id: String(ProductId),
    searchText:  currentSearchQuerySale,
});

   useEffect(() => {
      if (debouncedSearchQuerySale.length >= 4 || debouncedSearchQuerySale === "") {
        setCurrentSearchQuerySale(debouncedSearchQuerySale);
      //  refetch();
      }
    }, [debouncedSearchQuerySale]);
  

  const { data: productBrandData, isLoading: productBrandLoading } =
    useGetProductBrandQuery({
      searchText: "",
      isActive: true,
    });

  const { data: tagData, isLoading: tagLoading } = useGetProductTagQuery({
    searchText: "",
    isActive: true,
  });

  const { data: printerData, isLoading: printerLoading } = useGetPrinterQuery({
    searchText: "",
  });

  const { data: categoryData, isLoading: categoryLoading } =
    useGetCategoryQuery();

    const [selectedCategoryId, setSelectedCategoryId] = useState<number | null>(
        null
      );
      const [selectedSubCategoryId, setSelectedSubCategoryId] = useState<
        number | null
      >(null);
    
      const [selectedSubToSubCategoryId, setSelectedSubToSubCategoryId] = useState<
        number | null
      >(null);
    
      const [selectedSubToSubToSubCategoryId, setSelectedSubToSubToSubCategoryId] =
        useState<number | null>(null);
    
      const { data: subCategoryData, refetch: refetchSubCategories } =
        useGetSubCategoryByArrayQuery({
          parent_ids: selectedCategoryId ? [Number(selectedCategoryId)] : [],
        });
    
      const { data: subCategory2Data, refetch: refetchS2bCategories } =
        useGetSubCategoryByArrayQuery({
          parent_ids: selectedSubCategoryId
            ? [Number(selectedCategoryId), Number(selectedSubCategoryId)]
            : [],
        });
    
      const { data: subCategory3Data, refetch: refetchS3bCategories } =
        useGetSubCategoryByArrayQuery({
          parent_ids: selectedSubCategoryId
            ? [
                Number(selectedCategoryId),
                Number(selectedSubCategoryId),
                Number(selectedSubToSubCategoryId),
              ]
            : [],
        });
    
   
      const subCategoryList = useMemo(() => {
        return subCategoryData?.data as ICategory[];
      }, [subCategoryData?.data]);
    
      const subToSubCategoryList = useMemo(() => {
        return subCategory2Data?.data as ICategory[];
      }, [subCategory2Data?.data]);
    
      const subToSubToSubCategoryList = useMemo(() => {
        return subCategory3Data?.data as ICategory[];
      }, [subCategory3Data?.data]);
    
      const productCategoryId = selectedSubToSubToSubCategoryId
        ? Number(selectedSubToSubToSubCategoryId)
        : selectedSubToSubCategoryId
        ? Number(selectedSubToSubCategoryId)
        : selectedSubCategoryId
        ? Number(selectedSubCategoryId)
        : selectedCategoryId
        ? Number(selectedCategoryId)
        : String("");



  const product = useMemo(() => {
    if (data && Array.isArray(data.data) && data.data.length > 0) {
      return data.data[0] as IEventPopUP;
    }
    return null;
  }, [data]);



// React.useEffect(() => {
//   if (product?.modifierGroupId) {
//     if (typeof product.modifierGroupId === "string") {
//       try {
//         const parsed: ModifierGroupSelection[] = JSON.parse(product.modifierGroupId);
//         // Normalize required field to always be boolean
//         const normalized = parsed.map(item => ({
//           modifierGroupId: item.modifierGroupId,
//           required: item.required ?? false,
//           order: item.order ?? null, 
//           maximum: item.maximum ?? null,
//           minimum: item.minimum ?? null,
//              modifiers: Array.isArray(item.modifiers) ? item.modifiers : [], 
//         }));
//         setSelectedModifierGroups(normalized);
//       } catch (err) {
//         console.error("Failed to parse modifierGroupId", err);
//         setSelectedModifierGroups([]);
//       }
//     } else if (Array.isArray(product.modifierGroupId)) {
//       // Normalize required field to always be boolean
//       const normalized = product.modifierGroupId.map((item: any) => ({
//         modifierGroupId: item.modifierGroupId,
//         required: item.required ?? false,
//         order: item.order ?? null, 
//         maximum: item.maximum ?? null,
//         minimum: item.minimum ?? null,
// modifiers: Array.isArray(item.modifiers) ? item.modifiers : [], 
//       }));
//       setSelectedModifierGroups(normalized);
//     } else {
//       setSelectedModifierGroups([]);
//     }
//   } else {
//     setSelectedModifierGroups([]);
//   }
// }, [product]);







 const { data: variantData, isLoading: variantLoading } =
    useGetVariantQuery({  searchText: "",
    id: null,
    productId: String(ProductId),
    productBrandId: null,
    productCategoryId: null,
    productTagIds: null,
    productViewOnline: null,
    createdDateStart: null,
    createdDateEnd: null,
    createdDate: null,
  });

  // const { data: modifierGroupData, isLoading: modifierLoading } = useGetModifierGroupQuery({
  //   productBrandId: selectedProductBrandId,
  //   productCategoryId: String(productCategoryId),
  //   productTagIds: selectedProductTagIds,
  //   modifierViewOnline: selectedProductViewOnline,
  //   createdDateStart: startDateAsDate as Date,
  //   createdDateEnd: endDateAsDate as Date,
  //   searchText: currentSearchQuery,
  //   createdDate: getFormattedDate(createDate),
  //   id: null,
  // });

    const { data: modifierGrpData, isLoading: modifierGrpLoading } = useGetModifierGrpQuery({
    productBrandId: selectedProductBrandId,
    productCategoryId: String(productCategoryId),
    productTagIds: selectedProductTagIds,
    modifierViewOnline: selectedProductViewOnline,
    createdDateStart: startDateAsDate as Date,
    createdDateEnd: endDateAsDate as Date,
    searchText: currentSearchQuery,
    createdDate: getFormattedDate(createDate),
    id: null,
  });


    // const { data: modifierData } = useGetModifierQuery({
    //      productBrandId:  null,
    //     productCategoryId:  null,
    //     productTagIds: null,
    //     modifierViewOnline:null,
    //     createdDateEnd:  null,
    //     createdDateStart:null,
    //     searchText: null,
    //     createdDate: null,
    //     id:  "",
    //     });

         const { data: inventoryData, isLoading: invntoryLoading, isError: inventoryError, refetch: inventoryRefecth } = useGetInventoryQuery({
              searchText: currentSearchQuery,
              id: String(ProductId),
            });
        
              const inventoryList: IProductInventory[] = Array.isArray(inventoryData?.data)
            ? (inventoryData?.data as IProductInventory[])
            : [];

const totalStock = inventoryList?.reduce(
  (acc, item) => acc + Number(item.finalStock  || 0),
  0
) ?? 0;

const cost = inventoryList?.reduce(
  (acc, item) => acc + Number(item.avgBuyPrice || 0),
  0
) ?? 0;



// const netTotal = inventoryList?.reduce(
//   (acc, item) => acc + Number(item.netCost || 0),
//   0
// ) ?? 0;

const netTotal = totalStock  * cost ;

const sellingPrice = inventoryList?.reduce(
  (acc, item) => acc + Number(item.sellingPrice || 0),
  0
) ?? 0;

//             const inventoryList = inventory.find(
//   (inv) => String(inv.productId) === String(ProductId)
// );


    const coursings: IVariantPopUP[] = Array.isArray(variantData?.data)
      ? (variantData?.data as IVariantPopUP[])
      : [];

        const serializedList: ISerializedItem[] = Array.isArray(allSerializedData?.data)
      ? (allSerializedData?.data as ISerializedItem[])
      : [];

      const filteredSerializedList = serializedList.filter(
  (item) => !item.isSold
);


   const soldList: ISold[] = Array.isArray(soldData?.data)
      ? (soldData?.data as ISold[])
      : [];

      const invoiceList: IInvoice[] = Array.isArray(invoiceData?.data)
        ? (invoiceData?.data as IInvoice[])
        : [];

  // const modifierGroupList: IModifierGroupPopUp[] = Array.isArray(modifierGroupData?.data)
  // ? (modifierGroupData?.data as IModifierGroupPopUp[])
  //         : [];

           const modifierGrpList: IModifierGrpPopUp[] = Array.isArray(modifierGrpData?.data)
  ? (modifierGrpData?.data as IModifierGrpPopUp[])
          : [];

          React.useEffect(() => {
  if (!product?.modifierGroupId) return;

  const modifierIds = Array.isArray(product.modifierGroupId)
    ? product.modifierGroupId.map((id) => String(typeof id === "number" ? id : id.modifierGroupId))
    : [];

  setSelectedModifierGrpIds(modifierIds);
}, [product]);


React.useEffect(() => {
  if (!product?.modifierGroupId || !Array.isArray(product.modifierGroupId)) {
    setSelectedModifierGrps([]);
    setSelectedModifierGrpIds([]);
    return;
  }

  // Normalize product.modifierGroupId (now an array of {id, modifiers})
  const normalized: ModifierGrpSelection[] = product.modifierGroupId.map((grp: any) => {
    const group = modifierGrpList.find((mg) => Number(mg.id) === Number(grp.id));

    return {
      modifierGroupId: Number(grp.id),
      modifierGroupName: group?.modifierGroupName || "Unnamed Group",
        order: grp.order,
       minimum: grp.minimum ?? 0,   // include min
       maximum: grp.maximum ?? 0,   // include max
       modifiers: (grp.modifiers || []).map((mod: any) => ({
        product_id: String(mod.product_id),
        productName: mod.productName,
        price: mod.price ?? 0,
        pos: mod.pos ?? false,
        online: mod.online ?? false,
      })),
    };
  });
//console.log(normalized)
  setSelectedModifierGrps(normalized);

  // Initialize checkbox IDs
  setSelectedModifierGrpIds(normalized.map((grp) => String(grp.modifierGroupId)));
}, [product, modifierGrpList]);




  const products: IEventPopUP[] = Array.isArray(allProductsData?.data)
  ? (allProductsData?.data as IEventPopUP[])
          : []; 

  // const modifierList = useMemo(() => {
  // return modifierData?.data as IModifierPopUp[];
  //   }, [modifierData?.data]);

// const filteredModifierGroups = modifierGroupList.filter(
//   (group) =>
//     !selectedModifierGroups.some(
//       (selected) => Number(selected.modifierGroupId) === Number(group.id)
//     )
// );

// const filteredProducts = products.filter(
//   (group) => !linkedProducts.some(
//     (selectedId) => Number(selectedId) === Number(group.id) 
//   )
// );


  const productBrandList = useMemo(() => {
    return productBrandData?.data as IProductBrand[];
  }, [productBrandData?.data]);

  const productTagList = useMemo(() => {
    return tagData?.data as IProductTag[];
  }, [tagData?.data]);

  const printerList = useMemo(() => {
    return printerData?.data as IPrinter[];
  }, [printerData?.data]);

  const categoryList = useMemo(() => {
    return categoryData?.data as ICategory[];
  }, [categoryData?.data]);

  const productBrandMap = useMemo(() => {
    const map = new Map();
    productBrandList?.forEach((brand) => {
      map.set(brand.id, brand.productBrandName);
    });
    return map;
  }, [productBrandList]);

  const productTagMap = useMemo(() => {
    const map = new Map();
    productTagList?.forEach((tag) => {
      map.set(tag.id, tag.tagName);
    });
    return map;
  }, [productTagList]);

  const ProductPrinterMap = useMemo(() => {
    const map = new Map();
    printerList?.forEach((printer) => {
      map.set(printer.id, printer.printerName);
    });
    return map;
  }, [printerList]);

  const categoryMap = useMemo(() => {
    const map = new Map();
    categoryList?.forEach((category) => {
      map.set(category.id, category.categoryName);
    });
    return map;
  }, [categoryList]);


 const savedGroups = Array.isArray(product?.modifierGroupId)
  ? product?.modifierGroupId
  : JSON.parse(product?.modifierGroupId || "[]");

  const cardsData = [
  // {
  //   title: "Active",
  //   value: product?.productCanSell,
  // },
  {
    title: "Bookings",
    value: product?.sold_quantity ?? 0,
  },
 {
    title: "POS",
    value: product?.viewPos,
  },
  {
    title: "Online",
    value: product?.viewOnline,  // Adjust if needed differently
  },
//   {
//     title: "Sales",
//     value: soldList?.reduce(
//   (sum, item) => sum + Number(item.quantity || 0),
//   0
// ) ?? 0
//   },
  {
  title: "Food",
    value: product?.includes_food, 
  },
];

const cardIcons: Record<string, JSX.Element> = {
  Stock: <Inventory2Icon sx={{ mr: 1 }} />,
  POS: <PointOfSaleIcon sx={{ mr: 1 }} />,
  Online: <LanguageIcon sx={{ mr: 1 }} />,
  // "Sales": <PointOfSaleIcon sx={{ mr: 1 }} />,
  Food: <RestaurantIcon  sx={{ mr: 1 }} />,
};


 const handleCreateOpenDialog = () => {
    setOpenCreateVariantDialog(true);
  };

  const handleCreateCloseDialog = () => {
    setOpenCreateVariantDialog(false);
  };

  const handleOpenDialog = (product: IVariantPopUP) => {
    setSelectedProduct(product);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setSelectedProduct(null);
    setOpenDialog(false);
  };

  const handleOpenDeletePopup = (product: IVariantPopUP) => {
    setProductToDelete(product);
    setOpenDeleteProduct(true);
  };

  const handleCloseDeletePopup = () => {
    setProductToDelete(null);
    setOpenDeleteProduct(false);
  };

  
  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };


//   const handleAddModifierGroup = (group: IModifierGroupPopUp) => {
//   const alreadyExists = selectedModifierGroups.some((g) => g.id === group.id);
//   if (!alreadyExists) {
//     setSelectedModifierGroups([...selectedModifierGroups, group]);
//   }
//   setShowModifierGroupPopup(false);
// };


   const [deleteVariant] = useDeleteVariantMutation();
  const handleDelete = async (id: string) => {
    try {
      const response = await deleteVariant(id).unwrap();
      if (response.status) {
        showMessage("Deleted successfully");
        setOpenDeleteProduct(false);
      } else {
        showErrorMessage("Failed to delete the variant");
      }
    } catch (error) {
      showErrorMessage("Failed to delete the variant");
    }
  };


//  const handleCheckboxToggle = (id: number) => {
//   setSelectedModifierGroups(prev => {
//     const exists = prev.find(item => item.modifierGroupId === id);
    
//     if (exists) {
//       // Remove the modifier group if already selected
//       return prev.filter(item => item.modifierGroupId !== id);
//     } else {
//       // Add new modifier group WITHOUT assigning order by default
//       return [
//         ...prev,
//         {
//           modifierGroupId: id,
//           required: false,
//           order: null,  // or simply omit this line if your type allows
//           maximum: null,
//           minimum: null,
//         },
//       ];
//     }
//   });
// };



// const handleSaveModifierGroups = async () => {
//   const payload = {
//     productId: String(ProductId), // or get from props/state
//     modifierGroupId: JSON.stringify(selectedModifierGroups), // Must be JSON string
//   };

//   try {
//     const response = await axios.put(`${API_URL}/update-modifierGroup`,
//       payload,
//       {
//          headers: {
//           'Content-Type': 'application/json',
//            Authorization: `Bearer ${localStorage.getItem('token') || ''}`, // Include token from localStorage
//            },
//       }
//     );

//     if (response.data.status) {
//       // console.log('Update successful:', response.data.message);
//       showMessage('Modifier groups added!');
//       refetchProduct();
//       setShowModifierGroupPopup(false); // Close dialog
//     } else {
//       showErrorMessage(response.data.message || 'Update failed');
//     }
//   } catch (error) {
//     console.error('Error updating modifier group:', error);
//     showErrorMessage('Something went wrong');
//   }
// };


// const handleSaveModifierGroups = async () => {
//   if (!modifierGroupDetails) return;



//   const groupId = Number(modifierGroupDetails.id);

//   // Check if this group already exists in the selectedModifierGroups array
//   const exists = selectedModifierGroups.some(g => g.modifierGroupId === groupId);

//   // Prepare the new/updated group data object
//   const newGroup = {
//     modifierGroupId: groupId,
//     required: modifierGroupDetails.required ?? false,
//     order: modifierGroupDetails.order ?? null,
//     minimum: modifierGroupDetails.minimum ?? 0,
//     maximum: modifierGroupDetails.maximum ?? 0,
//     modifiers: (modifierGroupDetails.modifiers || []).map((mod: any) => ({
//       modifier_id: mod.modifier_id,
//       overwrite: mod.overwrite ?? false,
//       overwrite_price: mod.overwrite_price ?? null,
//     })),
//   };

//   const isDuplicateOrder = selectedModifierGroups.some(g =>
//     g.modifierGroupId !== groupId && g.order === newGroup.order
//   );

//   if (isDuplicateOrder) {
//     showErrorMessage(`Order number ${newGroup.order} is already used. Please choose a different one.`);
//     return;
//   }

//   // Create updated array with new or replaced group
//   let updatedGroups = [];
//   if (exists) {
//     updatedGroups = selectedModifierGroups.map(g =>
//       g.modifierGroupId === groupId ? newGroup : g
//     );
//   } else {
//     updatedGroups = [...selectedModifierGroups, newGroup];
//   }

//   // Update local state immediately for responsiveness
//   setSelectedModifierGroups(updatedGroups);

//   // Prepare payload for API
//   const payload = {
//     productId: String(ProductId), // Make sure ProductId is in your component scope
//     modifierGroupId: JSON.stringify(updatedGroups),
//   };

//   try {
//     const response = await axios.put(`${API_URL}/update-modifierGroup`, payload, {
//       headers: {
//         'Content-Type': 'application/json',
//         Authorization: `Bearer ${localStorage.getItem('token') || ''}`,
//       },
//     });

//     if (response.data.status) {
//       showMessage('Modifier groups saved successfully!');
//       refetchProduct();  // Optional: refetch your product data if needed
//       setShowModifierGroupPopup(false);
//       setSelectedModifierGroupId(null);
//       setModifierGroupDetails(null);
//     } else {
//       showErrorMessage(response.data.message || 'Failed to save modifier groups.');
//     }
//   } catch (error) {
//     console.error('Error saving modifier groups:', error);
//     showErrorMessage('Something went wrong. Please try again.');
//   }
// };

// const handleSaveLinkedProducts = async () => {
//   if (!linkedProducts || linkedProducts.length === 0) return;

//   // Get only IDs of newly selected products
//   const newLinkedIds = linkedProducts.map(p => p.id);

//   // Get previously saved linked product IDs from `product.linkedProductId`
//   let previousIds: number[] = [];
//   if (product?.linkedProductId) {
//     try {
//       const parsed = JSON.parse(product.linkedProductId); // e.g., [1,2]
//       previousIds = Array.isArray(parsed) ? parsed : [];
//     } catch {
//       previousIds = [];
//     }
//   }

//   // Merge previous and new IDs
//   const allIds = Array.from(new Set([...previousIds, ...newLinkedIds]));

//   try {
//     const response = await axios.put(`${API_URL}/update-linkedProducts`, {
//       productId: String(ProductId),
//       linkedProductIds: JSON.stringify(allIds), // send full array
//     }, {
//       headers: {
//         'Content-Type': 'application/json',
//         Authorization: `Bearer ${localStorage.getItem('token') || ''}`,
//       },
//     });

//     if (response.data.status) {
//       showMessage('Linked products saved successfully!');
//       refetchProduct();
//       setShowLinkedProductPopup(false);
//     } else {
//       showErrorMessage(response.data.message || 'Failed to save linked products.');
//     }
//   } catch (error) {
//     console.error('Error saving linked products:', error);
//     showErrorMessage('Something went wrong. Please try again.');
//   }
// };


const handleSaveModifierGrps = async () => {
  // if (!selectedModifierGrpIds || selectedModifierGrpIds.length === 0) {
  //   showErrorMessage("Please select at least one modifier group.");
  //   return;
  // }

  // Build payload: include modifiers from activeGroup if selected
  const modifierGroupsPayload = selectedModifierGrpIds.map((id, index) => {
    const numericId = Number(id);

    let modifiers: ProductInfo[] = [];

    // If activeGroup matches, use its current modifiers
    if (activeGroup?.modifierGroupId === numericId && activeGroup.modifiers?.length) {
      modifiers = activeGroup.modifiers;
    } else {
      // Otherwise, get default modifiers from modifierGroupList
      const groupFromTable = modifierGrpList.find((g) => Number(g.id) === numericId);
      modifiers = groupFromTable?.modifiers || [];
    }

  //   const minVal = modifierGrpDetails.find((g) => Number(g.id) === numericId)?.minimum || "";
  // const maxVal = modifierGrpDetails.find((g) => Number(g.id) === numericId)?.maximum || "";

    const groupDetail = modifierGrpDetails.find((g) => Number(g.id) === numericId);

  const minVal = groupDetail?.minimum ?? activeGroup?.minimum ?? "";
  const maxVal = groupDetail?.maximum ?? activeGroup?.maximum ?? "";

    let maxOrder = Math.max(0, ...selectedModifierGrps.map(g => g.order ?? 0));
      const order = groupDetail?.order ?? ++maxOrder;
  

    return {
       id: numericId,
       order,
       minimum: minVal,
       maximum: maxVal,
      modifiers,
    };
  });

  const payload = {
    productId: Number(ProductId),
    modifierGroups: modifierGroupsPayload,
  };

  try {
    const response = await axios.put(`${API_URL}/update-modifierGrp`, payload, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token") || ""}`,
      },
    });

    if (response.data.status) {
      showMessage("Modifier group and modifiers saved successfully!");
    setViewMode("groupList");      // Update activeGroup locally so the table reflects current values
      const savedGroup = modifierGroupsPayload.find(
        (g) => g.id === activeGroup?.modifierGroupId
      );

      if (savedGroup) {
        const groupFromTable = modifierGrpList.find(
          (g) => Number(g.id) === savedGroup.id
        );

        setActiveGroup({
          modifierGroupId: savedGroup.id,
          modifierGroupName: groupFromTable?.modifierGroupName || "",
          minimum: savedGroup.minimum || "",
          maximum: savedGroup.maximum || "",
          modifiers: savedGroup.modifiers as ProductInfo[],
        });
      }

      setShowModifierGrpPopup(false);
      setSelectedModifierGrpIds([]);
        // setSearchText("");
      refetchProduct();
    } else {
      showErrorMessage(response.data.message || "Failed to save modifier group.");
    }
  } catch (error) {
    console.error("Error saving modifier group:", error);
    showErrorMessage("Something went wrong. Please try again.");
  }
};

const updateModifierGrpOrder = async (updatedModifierGrps: any[]) => {
  try {
    const payload = updatedModifierGrps.map((grp, index) => ({
      id: grp.id,       // keep original id
      order: index + 1, // updated order
    }));

    const response = await axios.put(`${API_URL}/update-modifierGrpOrder`, {
      productId: Number(ProductId),
      modifierGroups: payload,
    }, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token") || ""}`,
      },
    });

    if (response.data.status) {
      showMessage("Modifier group order updated successfully!");
      // Optionally refetch data to show updated order
      refetchProduct();
    } else {
      showErrorMessage(response.data.message || "Failed to update order");
    }
  } catch (error) {
    console.error("Error updating modifier group order:", error);
    showErrorMessage("Something went wrong while updating order");
  }
};






const handleEditModifierGroup = (group: ModifierGroupSelection) => {
  setSelectedModifierGroupId(group.modifierGroupId);
  setModifierGroupDetails({
     id: String(group.modifierGroupId), 
    required: group.required,
    order: group.order ?? undefined,
    minimum: group.minimum,
    maximum: group.maximum,
    modifiers: group.modifiers ?? [],
  });
  setShowModifierGroupPopup(true);
};

const handleDeleteModifierGroup = async (modifierGroupId: number) => {
  const confirmed = window.confirm("Are you sure you want to delete this modifier group?");
  if (!confirmed) return; // Exit if user cancels

  // Remove locally
  const updatedGroups = selectedModifierGroups.filter(g => g.modifierGroupId !== modifierGroupId);


  // Update backend (optional)
  try {
    await axios.put(`${API_URL}/update-modifierGroup`, {
      productId: String(ProductId),
      modifierGroupId: JSON.stringify(updatedGroups),
    }, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token') || ''}`
      }
    });

    showMessage('Modifier Group deleted successfully');
    setSelectedModifierGroups(updatedGroups);
  } catch (error) {
    console.error(error);
    showErrorMessage('Failed to delete Modifier Group');
  }
};

// const handleDeleteLinkedProduct = async (linkedProductId: any) => {
//   const confirmed = window.confirm("Are you sure you want to delete this linked product?");
//   if (!confirmed) return; // Exit if user cancels

//   // Remove locally
//   const updatedGroups = linkedProducts.filter((id) => id !== linkedProductId);

//   try {
//     await axios.put(`${API_URL}/update-linkedProducts`, {
//       productId: String(ProductId),
//       linkedProductIds: JSON.stringify(updatedGroups),
//     }, {
//       headers: {
//         Authorization: `Bearer ${localStorage.getItem('token') || ''}`
//       }
//     });
//     showMessage('Linked product deleted successfully');
//     setLinkedProducts(updatedGroups);
//   } catch (error) {
//     console.error(error);
//     showErrorMessage('Failed to delete Linked product');
//   }
// };


// const handleInlineModUpdate = (
//   idx: number,
//   field: "price" | "online" | "pos",
//   value: any,
//   selectedRows: Record<number, boolean>
// ) => {
//   const updatedModifiers = [...activeGroup!.modifiers];

//   if (Object.values(selectedRows).some((v) => v)) {
//     // update only selected rows
//     updatedModifiers.forEach((mod, i) => {
//       if (selectedRows[Number(mod.product_id)]) {
//         updatedModifiers[i] = { ...mod, [field]: value };
//       }
//     });
//   } else {
//     // update current row if none selected
//     updatedModifiers[idx] = { ...updatedModifiers[idx], [field]: value };
//   }

//   setActiveGroup({ ...activeGroup!, modifiers: updatedModifiers });
// };

const applyBulkToggle = (field: "pos" | "online") => {
  if (!activeGroup?.modifiers) return;

  const updatedModifiers = activeGroup.modifiers.map((mod) => {
    if (selectedRows[Number(mod.product_id)]) {
      return { ...mod, [field]: !mod[field] };
    }
    return mod;
  });

  setActiveGroup({ ...activeGroup, modifiers: updatedModifiers });
};



const applyPriceUpdate = () => {
  if (!activeGroup || !activeGroup.modifiers) return;

  const updatedModifiers = activeGroup.modifiers.map((mod) =>
    selectedRows[Number(mod.product_id)]
      ? { ...mod, price: Number(priceValue) }
      : mod
  );

  setActiveGroup({ ...activeGroup, modifiers: updatedModifiers });
  setOpenPriceDialog(false);
};

const fetchStockHistory = async () => {
    setLoading(true);
  const res = await axios.get(`${API_URL}/stock-history/${ProductId}`, { 
     headers: {
          'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem('token') || ''}`
        },});
      
  setStockHistory(res.data);
      setLoading(false);
};

const fetchInvCostHistory = async () => {
  setLoading(true);
  const res = await axios.get(`${API_URL}/inv-cost-history/${ProductId}`, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${localStorage.getItem('token') || ''}`,
    },
  });
  setInvCostHistory(res.data);
  setLoading(false);
};

const fetchCostHistory = async () => {
  setLoading(true);
  const res = await axios.get(`${API_URL}/cost-history/${ProductId}`, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${localStorage.getItem('token') || ''}`,
    },
  });
  setCostHistory(res.data);
  setLoading(false);
};

const fetchSellingPriceHistory = async () => {
  setLoading(true);
  const res = await axios.get(`${API_URL}/selling-price-history/${ProductId}`, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${localStorage.getItem('token') || ''}`,
    },
  });
  setSellingPriceHistory(res.data);
  setLoading(false);
};

const handleSave = async () => {
    try {
      await axios.post(`${API_URL}/save-manual-price`, {
        productId: product?.id,
        reg_price: regPrice,
        sale_price: salePrice
      },  {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('token') || ''}`,
        },
      });

    showMessage('Price updated successfully');

  refetchProduct();
      setOpen(false);
    } catch (err) {
      console.error(err);
      showErrorMessage('Error updating price');
    }
  };

const handleEditClick = () => {
  if (!product) return;

  setRegPrice(Number(product.salePrice) || 0);
  setSalePrice(Number(product.offerPrice) || 0);
  setOpen(true);
};

const handleManualStockSubmit = async () => {
  if (!manualQty) return alert("Quantity is required");

  try {
    setLoading(true);

     const finalQty =
      adjustType === "deduct" ? -Math.abs(Number(manualQty)) : Math.abs(Number(manualQty));

    await axios.post(`${API_URL}/stock/manual`, {
      product_id: ProductId,
      qty: finalQty,
      reason: manualReason,
    },  {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('token') || ''}`,
        },
      });

        showMessage('Stock adjusted successfully');

    setOpenManualModal(false);
    setManualQty("");
    setManualReason("");
    setAdjustType("add");

    // 🔄 Refresh stock history
    await fetchStockHistory();

  } catch (error) {
    console.error(error);
    showErrorMessage('Failed to adjust stock');
  } finally {
    setLoading(false);
  }
};
const handleMenuOpen = (
  event: React.MouseEvent<HTMLElement>,
  row: ISerializedItem
) => {
  setMenuAnchor(event.currentTarget);
  setSelectedRow(row);
};

const handleMenuClose = () => {
  setMenuAnchor(null);
};

const handleAction = (status: "sold" | "out_of_stock") => {
  setSelectedStatus(status);
  setMenuAnchor(null);
  setOpenRemarkDialog(true);
};

const closeRemarkDialog = () => {
  setOpenRemarkDialog(false);
  setRemarks("");
  setSelectedStatus("");
};

const handleConfirmStatusUpdate = async () => {
  if (!remarks.trim() || !selectedRow) return;

  try {
    await axios.post(`${API_URL}/serial/update-status`, {
    serialized_id: selectedRow.id,   // matches serialized_manual table
      productId: ProductId,
      status: selectedStatus,
      remarks: remarks.trim(),
    },{
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token') || ''}`,
        },
      });

    showMessage("Serial status updated successfully");

   // fetchSerializedStock(); // 🔄 refresh list
    closeRemarkDialog();
  } catch (err) {
    showErrorMessage("Failed to update serial status");
  }
};


  if (
    isLoading ||
    productBrandLoading ||
    tagLoading ||
    printerLoading ||
    categoryLoading
  ) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="10vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  if (isError) {
    return (
      <Typography color="error">
        Error fetching product details data. Please try again later.
      </Typography>
    );
  }

 





  return (
    <Grid container spacing={3}>
      <Grid item lg={12} md={12} sm={12} xs={12}>
        <Card className={classes.stepperCard}>
          <Grid
            container
            justifyContent={"space-between"}
            spacing={5}
            sx={{ borderBottom: 2, padding: 2 }}
            className={classes.titleGrid}
          >
            <Grid
              item
              lg={9}
              md={9}
              sm={9}
              xs={9}
              pt={2}
              alignContent={"center"}
            >
              <Typography variant="h3">{product?.name}</Typography>
               {/* <Grid item>
        <Typography variant="body2" color="textSecondary">
          Created By: {product?.created_by ?? '-'}
        </Typography>
    
        <Typography variant="body2" color="textSecondary">
          Created At: {product?.created_at ? dayjs(product?.created_at).format("MMM D, YYYY [at] h:mm A") : "-"}
        </Typography>
      </Grid> */}
            </Grid>
            <Grid
              item
              lg={3}
              md={3}
              sm={3}
              xs={3}
              pt={2}
              sx={{ display: "flex", justifyContent: "flex-end" }}
            >
              <Grid
                container
                spacing={1}
                justifyContent="flex-end"
                sx={{ display: "flex" }}
              >
                
     
   

                <Grid item>
                  <Button
                    variant="outlined"
                  startIcon={<ArrowBackIosNewIcon sx={{ fontSize: 40 }} />}
                    className={classes.addButton}
                    onClick={() => navigate(-1)}
                  >
                    Back
                  </Button>
                  
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Card>
      </Grid>
      <Grid item lg={3} md={3} sm={12} xs={12}>
        <Grid container spacing={2}>

          <Grid item lg={12} md={12} sm={12} xs={12}>
            <Card className={classes.stepperCard}>
              <Grid container spacing={2}>
              


      <Grid item lg={12} md={12} sm={12} xs={12} pt={2}>
                  <Grid
                    container
                    justifyContent={"space-between"}
                    spacing={5}
                    sx={{ borderBottom: 2, padding: 2 }}
                    className={classes.titleGrid}
                  >
                    <Grid
                      item
                      lg={12}
                      md={12}
                      sm={12}
                      xs={12}
                      pt={2}
                     
                      alignContent={"center"}
                    >
                     <Grid item lg={12} md={12} sm={12} xs={12}>
            <Card className={classes.stepperCard}>
              <Grid container spacing={1} >
                <Grid item lg={12} md={12} sm={12} xs={12} pt={2}>
                  <Grid
                    container
                    justifyContent={"space-between"}
                    spacing={5}
                    sx={{ borderBottom: 2, padding: 2 }}
                    className={classes.titleGrid}
                  >
                    <Grid
                      item
                      lg={12}
                      md={12}
                      sm={12}
                      xs={12}
                      pt={2}
                      alignContent={"center"}
                    >





  <Grid item xs={12}>
        <Box
          sx={{
            width: "100%",
            height: 220,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderRadius: 2,
            overflow: "hidden",
            background: "#f5f5f5",
          }}
        >
          <img
            src={
              product?.img
                ? `${LARAVEL_API_URL}/${String(product?.img)}`
                : placeholderImage
            }
            alt="Product"
            style={{ maxWidth: "100%", maxHeight: "100%" }}
          />
        </Box>
      </Grid>

      {/* Barcode */}
      {/* {!product?.productManualBarcode && (
        <Grid item xs={12} textAlign="center">
          <Barcode value={product?.productBarcode ?? ""} />
        </Grid>
      )}

         {product?.productManualBarcode && (
        <Grid item xs={12} textAlign="center">
          <Barcode value={product?.productManualBarcode ?? ""} />
        </Grid>
      )} */}


{/* <Grid item xs={12} textAlign="center" sx={{ mt: 2 }}>
  <Box
    sx={{
      overflowX: "auto",
      display: "inline-block",
      maxWidth: "100%",
      '& svg rect': {
        fill: '#999',       // ash/light grey for bars
      },
      '& svg text': {
        fill: '#999',       // ash/light grey for text
        fontSize: '12px',    // small font size
      },
    }}
  >
    <Barcode
      value={product?.manualBarcode || product?.barcode || ""}
      width={1}           // bar thickness
      height={50}         // bar height
      displayValue={true} // show text below
      margin={0}
       fontOptions="light"
      renderer="svg" 
       textMargin={1}         // needed to style via sx
    />
  </Box>
</Grid> */}



      

      {/* Product Name */}
      <Grid item xs={12} textAlign="center">
        
        <Typography variant="subtitle1" fontWeight={700} fontSize={18}>
          {product?.name}
        </Typography>
      </Grid>

   <Grid item xs={12} textAlign="center">
  <Typography
    variant="subtitle1"
    fontWeight={700}
    fontSize={16}
  >

    {product?.offerPrice ? (
    <>
      <Typography
        component="span"
        sx={{ textDecoration: "line-through", color: "grey", marginRight: 1 }}
      >
        ${product?.salePrice ?? "0.00"}
      </Typography>
      <Typography component="span" sx={{ color: "green", fontWeight: 700 }}>
        ${product?.offerPrice}
      </Typography>
    </>
  ) : (
    <Typography component="span" sx={{ color: "green", fontWeight: 700 }}>
      ${product?.salePrice ?? "0.00"}
    </Typography>
  )}

   {/* <IconButton color="primary"  onClick={handleEditClick}>
            <EditSharpIcon style={{ fontSize: 16, marginRight:'2px' }} />
            </IconButton> */}

   

  </Typography>

 
    
</Grid>


                   
                    </Grid>
                  </Grid>
                </Grid>

       

<TableContainer
  component={Paper}
  sx={{
    boxShadow: "none",
    borderRadius: 2,
    overflow: "hidden",
  }}
>
    <Table sx={{
               width: "100%",
               marginBottom: "1.5rem",  
               verticalAlign: "top",
               "& > :not(caption) > * > *": {
                 padding: "8px", // Ensure custom padding is applied
               },
             }}>
    <TableBody>
      {/* Category */}
      {/* <TableRow sx={{ borderBottom: "1px solid #e0e0e0" }}>
        <TableCell  className={classes.tablheader} sx={{ width: "10px", fontWeight: 600, textAlign: "left" }}>
          Category
        </TableCell>
        <TableCell   className={classes.tablheader}sx={{ fontWeight: 600, width: "10px" }}>:</TableCell>
        <TableCell  className={classes.tablheader}>
          {categoryMap.get(product?.categoryId) || "-"}
        </TableCell>
      </TableRow> */}

      {/* Brand */}
      {/* <TableRow sx={{ borderBottom: "1px solid #e0e0e0" }}>
        <TableCell className={classes.tablheader} sx={{ fontWeight: 600, textAlign: "left" }}>Brand</TableCell>
        <TableCell className={classes.tablheader} sx={{ fontWeight: 600, width: "10px" }}>:</TableCell>
        <TableCell className={classes.tablheader}>
          {productBrandMap.get(product?.brandId) || "-"}
        </TableCell>
      </TableRow> */}

      {/* Product Tag */}
      {/* <TableRow sx={{ borderBottom: "1px solid #e0e0e0" }}>
        <TableCell className={classes.tablheader} sx={{ fontWeight: 600, textAlign: "left" }}>Tag</TableCell>
        <TableCell className={classes.tablheader} sx={{ fontWeight: 600, width: "10px" }}>:</TableCell>
        <TableCell className={classes.tablheader}>
          {(product?.tagIds || [])
            .map((tagId) => productTagMap.get(tagId) || "")
            .join(", ")}
        </TableCell>
      </TableRow> */}

      {/* Conversion Unit */}
      {/* <TableRow sx={{ borderBottom: "1px solid #e0e0e0" }}>
        <TableCell className={classes.tablheader} sx={{ fontWeight: 600, textAlign: "left" }}>Unit</TableCell>
        <TableCell className={classes.tablheader} sx={{ fontWeight: 600, width: "10px" }}>:</TableCell>
        <TableCell className={classes.tablheader}>
          {product?.conversionUnit
            ?.map((unit) => {
              const unitLabel = Object.keys(SizeOfLevelType).find(
                (key) =>
                  SizeOfLevelType[key as keyof typeof SizeOfLevelType] === unit
              );
              return unitLabel;
            })
            .join(", ") || "-"}
        </TableCell>
      </TableRow> */}

      {/* Printers */}
      {/* <TableRow sx={{ borderBottom: "1px solid #e0e0e0" }}>
        <TableCell className={classes.tablheader} sx={{ fontWeight: 600, textAlign: "left" }}>Printers</TableCell>
        <TableCell className={classes.tablheader} sx={{ fontWeight: 600, width: "10px" }}>:</TableCell>
        <TableCell className={classes.tablheader}>
          {(product?.printerIds || [])
            .map((printerId) => ProductPrinterMap.get(printerId) || "")
            .join(", ")}
        </TableCell>
      </TableRow> */}

       <TableRow sx={{ borderBottom: "1px solid #e0e0e0" }}>
        <TableCell  className={classes.tablheader} sx={{ width: "10px", fontWeight: 600, textAlign: "left" }}>
          Group Slug
        </TableCell>
        <TableCell   className={classes.tablheader}sx={{ fontWeight: 600, width: "10px" }}>:</TableCell>
        <TableCell  className={classes.tablheader}>
          {product?.event_slug || "-"}
        </TableCell>
      </TableRow>

       <TableRow sx={{ borderBottom: "1px solid #e0e0e0" }}>
        <TableCell  className={classes.tablheader} sx={{ width: "10px", fontWeight: 600, textAlign: "left" }}>
          Grp Id
        </TableCell>
        <TableCell   className={classes.tablheader}sx={{ fontWeight: 600, width: "10px" }}>:</TableCell>
        <TableCell  className={classes.tablheader}>
          {product?.wp_page_id || "-"}
        </TableCell>
      </TableRow>

        <TableRow sx={{ borderBottom: "1px solid #e0e0e0" }}>
        <TableCell  className={classes.tablheader} sx={{ width: "10px", fontWeight: 600, textAlign: "left" }}>
          Start
        </TableCell>
        <TableCell   className={classes.tablheader}sx={{ fontWeight: 600, width: "10px" }}>:</TableCell>
        <TableCell  className={classes.tablheader}>
        
         {dayjs(product?.startDateTime).format("MMM D, YYYY h:mm A" || "-")}
        </TableCell>
      </TableRow>

        <TableRow sx={{ borderBottom: "1px solid #e0e0e0" }}>
        <TableCell  className={classes.tablheader} sx={{ width: "10px", fontWeight: 600, textAlign: "left" }}>
          End
        </TableCell>
        <TableCell   className={classes.tablheader}sx={{ fontWeight: 600, width: "10px" }}>:</TableCell>
        <TableCell  className={classes.tablheader}>
        
         {dayjs(product?.endDateTime).format("MMM D, YYYY  h:mm A" || "-")}
        </TableCell>
      </TableRow>


      <TableRow sx={{ borderBottom: "1px solid #e0e0e0" }}>
        <TableCell  className={classes.tablheader} sx={{ width: "10px", fontWeight: 600, textAlign: "left" }}>
          Open
        </TableCell>
        <TableCell   className={classes.tablheader}sx={{ fontWeight: 600, width: "10px" }}>:</TableCell>
        <TableCell  className={classes.tablheader}>
        
         {dayjs(product?.booking_open_at).format("MMM D, YYYY h:mm A" || "-")}
        </TableCell>
      </TableRow>

        <TableRow sx={{ borderBottom: "1px solid #e0e0e0" }}>
        <TableCell  className={classes.tablheader} sx={{ width: "10px", fontWeight: 600, textAlign: "left" }}>
          Close
        </TableCell>
        <TableCell   className={classes.tablheader}sx={{ fontWeight: 600, width: "10px" }}>:</TableCell>
        <TableCell  className={classes.tablheader}>
        
         {dayjs(product?.booking_close_at).format("MMM D, YYYY h:mm A" || "-")}
        </TableCell>
      </TableRow>

        <TableRow >
  <TableCell
    
    sx={{ textAlign: "left" }}
    colSpan={3} // spans all 3 columns of previous rows
  >
    <div
      dangerouslySetInnerHTML={{
        __html: product?.shortDescription || "",
      }}
    />
  </TableCell>
</TableRow>

    </TableBody>
  </Table>
</TableContainer>

                {/* <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Grid
                    container
                    justifyContent={"space-between"}
                    spacing={5}
                    sx={{ px: 2 }}
                    className={classes.titleGrid}
                  >
                    <Grid
                      item
                      lg={12}
                      md={12}
                      sm={12}
                      xs={12}
                      alignContent={"center"}
                      direction={"column"}
                    >
                      <Typography variant="subtitle1">
                        <span className={classes.customerDetails}>
                          Category :
                        </span>{" "}
                        {categoryMap.get(product?.productCategoryId) || ""}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Grid
                    container
                    justifyContent={"space-between"}
                    spacing={5}
                    sx={{ px: 2 }}
                    className={classes.titleGrid}
                  >
                    <Grid
                      item
                      lg={12}
                      md={12}
                      sm={12}
                      xs={12}
                      alignContent={"center"}
                      direction={"column"}
                    >
                      <Typography variant="subtitle1">
                        <span className={classes.customerDetails}>
                          Brand :
                        </span>{" "}
                        {productBrandMap.get(product?.productBrandId) || ""}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Grid
                    container
                    justifyContent={"space-between"}
                    spacing={5}
                    sx={{ px: 2 }}
                    className={classes.titleGrid}
                  >
                    <Grid
                      item
                      lg={12}
                      md={12}
                      sm={12}
                      xs={12}
                      alignContent={"center"}
                      direction={"column"}
                    >
                      <Typography variant="subtitle1">
                        <span className={classes.customerDetails}>
                          Product Tag :
                        </span>{" "}
                        {(product?.productTagIds || [])
                          .map((tagId) => productTagMap.get(tagId) || "")
                          .join(", ")}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Grid
                    container
                    justifyContent={"space-between"}
                    spacing={5}
                    sx={{ px: 2 }}
                    className={classes.titleGrid}
                  >
                    <Grid
                      item
                      lg={12}
                      md={12}
                      sm={12}
                      xs={12}
                      alignContent={"center"}
                      direction={"column"}
                    >
                      <Typography variant="subtitle1">
                        <span className={classes.customerDetails}>
                          Conversion unit :
                        </span>{" "}
                        {product?.productConversionUnit
                          ?.map((unit) => {
                            const unitLabel = Object.keys(SizeOfLevelType).find(
                              (key) =>
                                SizeOfLevelType[
                                  key as keyof typeof SizeOfLevelType
                                ] === unit
                            );
                            return unitLabel;
                          })
                          .join(", ") || " "}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Grid
                    container
                    justifyContent={"space-between"}
                    spacing={5}
                    sx={{ px: 2 }}
                    className={classes.titleGrid}
                  >
                    <Grid
                      item
                      lg={12}
                      md={12}
                      sm={12}
                      xs={12}
                      alignContent={"center"}
                      direction={"column"}
                    >
                      <Typography variant="subtitle1">
                        <span className={classes.customerDetails}>
                          Printers :
                        </span>{" "}
                        {(product?.productPrinterIds || [])
                          .map((tagId) => ProductPrinterMap.get(tagId) || "")
                          .join(", ")}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid> */}

  {/* {product?.productShortDescription && (
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Grid
                    container
                    justifyContent={"space-between"}
                    spacing={5}
                    sx={{ px: 2 }}
                    className={classes.titleGrid}
                  >
                    <Grid
                      item
                      lg={12}
                      md={12}
                      sm={12}
                      xs={12}
                      alignContent={"center"}
                      direction={"column"}
                    >
                      <Typography variant="subtitle1">
                        <span className={classes.customerDetails}>
                          Short Description :
                        </span>{" "}
                      <div
  dangerouslySetInnerHTML={{
    __html: product?.productShortDescription || "",
  }}
/>

                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
  )}

  {product?.productLongDescription && (
     <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Grid
                    container
                    justifyContent={"space-between"}
                    spacing={5}
                    sx={{ px: 2 }}
                    className={classes.titleGrid}
                  >
                    <Grid
                      item
                      lg={12}
                      md={12}
                      sm={12}
                      xs={12}
                      alignContent={"center"}
                      direction={"column"}
                    >
                      <Typography variant="subtitle1">
                       <span className={classes.customerDetails}>
                          Long Description :
                        </span>{" "}
                         <div
  dangerouslySetInnerHTML={{
    __html: product?.productLongDescription || "",
  }}
/>

                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>

)} */}





              </Grid>
            </Card>
          </Grid>










          
                    </Grid>
                  </Grid>
                </Grid>













              </Grid>
            </Card>
          </Grid>


           {/* <Grid item lg={12} md={12} sm={12} xs={12}>
            <Card className={classes.stepperCard} sx={{ minHeight: "250px" }}>
              <Grid container spacing={1}>
                <Grid item lg={12} md={12} sm={12} xs={12} pt={2}>
                  <Grid
                    container
                    justifyContent={"space-between"}
                    spacing={5}
                    sx={{ borderBottom: 2, padding: 2 }}
                    className={classes.titleGrid}
                  >
                    <Grid
                      item
                      lg={12}
                      md={12}
                      sm={12}
                      xs={12}
                      pt={2}
                      alignContent={"center"}
                    >
                      <Typography variant="subtitle1">
                        <span className={classes.customerDetails}>
                          Long Description :
                        </span>{" "}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Grid
                    container
                    justifyContent={"space-between"}
                    spacing={5}
                    sx={{ px: 2 }}
                    className={classes.titleGrid}
                  >
                    <Grid
                      item
                      lg={12}
                      md={12}
                      sm={12}
                      xs={12}
                      alignContent={"center"}
                      direction={"column"}
                    >
                      
                      <Typography variant="subtitle1">
                    
                         <div
  dangerouslySetInnerHTML={{
    __html: product?.productLongDescription || "",
  }}
/>
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Card>
          </Grid> */}
{/* 
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <Card className={classes.stepperCard}>
              <Grid container spacing={2}>
                <Grid item lg={12} md={12} sm={12} xs={12} pt={2}>
                  <Grid
                    container
                    justifyContent={"space-between"}
                    spacing={5}
                    sx={{ borderBottom: 2, padding: 2 }}
                    className={classes.titleGrid}
                  >
                    <Grid
                      item
                      lg={12}
                      md={12}
                      sm={12}
                      xs={12}
                      pt={2}
                      pb={5}
                      alignContent={"center"}
                    >
                      <Box className={classes.productBox}>
                        <img
                          // src={product?.productImg}
                          src={product?.productImg ?`${LARAVEL_API_URL}/${String(product?.productImg)}` : placeholderImage}
                          alt="Product"
                          style={{
                            maxWidth: "100%",
                            maxHeight: "100%",
                            objectFit: "cover", // Ensures the image covers the entire box
                          }}
                        />
                      </Box>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Card>
          </Grid>

{!product?.productManualBarcode && (
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <Card className={classes.stepperCard}>
              <Grid container spacing={2}>
                <Grid item lg={12} md={12} sm={12} xs={12} pt={2}>
                  <Grid
                    container
                    justifyContent={"space-between"}
                    spacing={5}
                    sx={{ borderBottom: 2, padding: 2 }}
                    className={classes.titleGrid}
                  >
                    <Grid
                      item
                      lg={12}
                      md={12}
                      sm={12}
                      xs={12}
                      pt={2}
                      pb={5}
                      alignContent={"center"}
                    >
                      <Box className={classes.productBarCodeBox}>
                        <Barcode value={product?.productBarcode ?? ""} />
                      </Box>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Card>
          </Grid>
        )} */}

{/* {product?.productManualBarcode ?
           <Grid item lg={12} md={12} sm={12} xs={12}>
            <Card className={classes.stepperCard}>
              <Grid container spacing={2}>
                <Grid item lg={12} md={12} sm={12} xs={12} pt={2}>
                  <Grid
                    container
                    justifyContent={"space-between"}
                    spacing={5}
                    sx={{ borderBottom: 2, padding: 2 }}
                    className={classes.titleGrid}
                  >
                    <Grid
                      item
                      lg={12}
                      md={12}
                      sm={12}
                      xs={12}
                      pt={2}
                      pb={5}
                      alignContent={"center"}
                    >
                      <Box className={classes.productBarCodeBox}>
                        <Barcode value={product?.productManualBarcode ?? ""} />
                      </Box>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Card>
          </Grid>
          : null} */}


          {/* <Grid item lg={12} md={12} sm={12} xs={12}>
            <Card className={classes.stepperCard}>
              <Grid container spacing={2}>
                <Grid item lg={12} md={12} sm={12} xs={12} pt={2}>
                  <Grid
                    container
                    justifyContent={"space-between"}
                    spacing={5}
                    sx={{ borderBottom: 2, padding: 2 }}
                    className={classes.titleGrid}
                  >
                    <Grid
                      item
                      lg={12}
                      md={12}
                      sm={12}
                      xs={12}
                      pt={2}
                      // pb={5}
                      alignContent={"center"}
                    >
                      <Box className={classes.productBarCodeBox}>
                        <Box
                          sx={{
                            marginLeft: 1,
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <Box
                            sx={{
                              width: 50,
                              height: 50,
                              backgroundColor:
                                product?.buttonColor ?? "",
                              marginLeft: 1,
                              border: "1px solid #d3d3d3",
                              borderRadius: "8px",
                            }}
                          />
                        </Box>
                      </Box>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Card>
          </Grid> */}
        </Grid>
      </Grid>

    <Grid item lg={9} md={9} sm={12} xs={12}>
        <Grid container spacing={2}>
          <Grid item lg={12} md={12} sm={12} xs={12}>
             {/*  <Grid container spacing={2}>
              <Grid item lg={3} md={3} sm={12} xs={12}>
                <Card
                  className={classes.stepperCard}
                  sx={{ minHeight: "150px" }}
                >
                  <Grid container spacing={1}>
                    <Grid item lg={12} md={12} sm={12} xs={12} pt={2}>
                      <Grid
                        container
                        justifyContent={"space-between"}
                        spacing={5}
                        sx={{ borderBottom: 2, padding: 2 }}
                        className={classes.titleGrid}
                      >
                        <Grid
                          item
                          lg={12}
                          md={12}
                          sm={12}
                          xs={12}
                          pt={2}
                          alignContent={"center"}
                        >
                          <Typography variant="subtitle1">
                            <span className={classes.customerDetails}>
                              Active :
                            </span>{" "}
                          </Typography>
                        </Grid>
                      </Grid>
                    </Grid>

                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <Grid
                        container
                        justifyContent="center"
                        alignItems="center"
                        spacing={5}
                        sx={{ px: 2 }}
                        className={classes.titleGrid}
                      >
                        <Grid
                          item
                          lg={12}
                          md={12}
                          sm={12}
                          xs={12}
                          container
                          justifyContent="center"
                          alignItems="center"
                          direction="column"
                          textAlign="center"
                        >
                          <Typography variant="subtitle1">
                            {product?.productCanSell ? (
                              <CheckRoundedIcon
                                color="success"
                                sx={{
                                  fontSize: "42px",
                                  // backgroundColor: "red",
                                  // borderRadius: "50%",
                                }}
                              />
                            ) : (
                              <ClearRoundedIcon
                                color="error"
                                sx={{
                                  fontSize: "42px",
                                  // backgroundColor: "red",
                                  // borderRadius: "50%",
                                }}
                              />
                            )}
                          </Typography>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Card>
              </Grid>
              <Grid item lg={3} md={3} sm={12} xs={12}>
                <Card
                  className={classes.stepperCard}
                  sx={{ minHeight: "150px" }}
                >
                  <Grid container spacing={1}>
                    <Grid item lg={12} md={12} sm={12} xs={12} pt={2}>
                      <Grid
                        container
                        justifyContent={"space-between"}
                        spacing={5}
                        sx={{ borderBottom: 2, padding: 2 }}
                        className={classes.titleGrid}
                      >
                        <Grid
                          item
                          lg={12}
                          md={12}
                          sm={12}
                          xs={12}
                          pt={2}
                          alignContent={"center"}
                        >
                          <Typography variant="subtitle1">
                            <span className={classes.customerDetails}>
                              Variant :
                            </span>{" "}
                          </Typography>
                        </Grid>
                      </Grid>
                    </Grid>

                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <Grid
                        container
                        justifyContent="center"
                        alignItems="center"
                        spacing={5}
                        sx={{ px: 2 }}
                        className={classes.titleGrid}
                      >
                        <Grid
                          item
                          lg={12}
                          md={12}
                          sm={12}
                          xs={12}
                          container
                          justifyContent="center"
                          alignItems="center"
                          direction="column"
                          textAlign="center"
                        >
                          <Typography variant="subtitle1">
                            {product?.hasVariants ? (
                              <CheckRoundedIcon
                                color="success"
                                sx={{
                                  fontSize: "42px",
                                  // backgroundColor: "red",
                                  // borderRadius: "50%",
                                }}
                              />
                            ) : (
                              <ClearRoundedIcon
                                color="error"
                                sx={{
                                  fontSize: "42px",
                                  // backgroundColor: "red",
                                  // borderRadius: "50%",
                                }}
                              />
                            )}
                          </Typography>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Card>
              </Grid>

              
              <Grid item lg={3} md={3} sm={12} xs={12}>
                <Card
                  className={classes.stepperCard}
                  sx={{ minHeight: "150px" }}
                >
                  <Grid container spacing={1}>
                    <Grid item lg={12} md={12} sm={12} xs={12} pt={2}>
                      <Grid
                        container
                        justifyContent={"space-between"}
                        spacing={5}
                        sx={{ borderBottom: 2, padding: 2 }}
                        className={classes.titleGrid}
                      >
                        <Grid
                          item
                          lg={12}
                          md={12}
                          sm={12}
                          xs={12}
                          pt={2}
                          alignContent={"center"}
                        >
                          <Typography variant="subtitle1">
                            <span className={classes.customerDetails}>
                              Modifier Group :
                            </span>{" "}
                          </Typography>
                        </Grid>
                      </Grid>
                    </Grid>

                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <Grid
                        container
                        justifyContent="center"
                        alignItems="center"
                        spacing={5}
                        sx={{ px: 2 }}
                        className={classes.titleGrid}
                      >
                        <Grid
                          item
                          lg={12}
                          md={12}
                          sm={12}
                          xs={12}
                          container
                          justifyContent="center"
                          alignItems="center"
                          direction="column"
                          textAlign="center"
                        >
                          <Typography variant="subtitle1">
                            {product?.hasVariants ? (
                              <CheckRoundedIcon
                                color="success"
                                sx={{
                                  fontSize: "42px",
                                  // backgroundColor: "red",
                                  // borderRadius: "50%",
                                }}
                              />
                            ) : (
                              <ClearRoundedIcon
                                color="error"
                                sx={{
                                  fontSize: "42px",
                                  // backgroundColor: "red",
                                  // borderRadius: "50%",
                                }}
                              />
                            )}
                          </Typography>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Card>
              </Grid>


              <Grid item lg={3} md={3} sm={12} xs={12}>
                <Card
                  className={classes.stepperCard}
                  sx={{ minHeight: "150px" }}
                >
                  <Grid container spacing={1}>
                    <Grid item lg={12} md={12} sm={12} xs={12} pt={2}>
                      <Grid
                        container
                        justifyContent={"space-between"}
                        spacing={5}
                        sx={{ borderBottom: 2, padding: 2 }}
                        className={classes.titleGrid}
                      >
                        <Grid
                          item
                          lg={12}
                          md={12}
                          sm={12}
                          xs={12}
                          pt={2}
                          alignContent={"center"}
                        >
                          <Typography variant="subtitle1">
                            <span className={classes.customerDetails}>
                              Product View Online :
                            </span>{" "}
                          </Typography>
                        </Grid>
                      </Grid>
                    </Grid>

                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <Grid
                        container
                        justifyContent="center"
                        alignItems="center"
                        spacing={5}
                        sx={{ px: 2 }}
                        className={classes.titleGrid}
                      >
                        <Grid
                          item
                          lg={12}
                          md={12}
                          sm={12}
                          xs={12}
                          container
                          justifyContent="center"
                          alignItems="center"
                          direction="column"
                          textAlign="center"
                        >
                          <Typography variant="subtitle1">
                            {product?.productViewOnline ? (
                              <CheckRoundedIcon
                                color="success"
                                sx={{
                                  fontSize: "42px",
                                  // backgroundColor: "red",
                                  // borderRadius: "50%",
                                }}
                              />
                            ) : (
                              <ClearRoundedIcon
                                color="error"
                                sx={{
                                  fontSize: "42px",
                                  // backgroundColor: "red",
                                  // borderRadius: "50%",
                                }}
                              />
                            )}
                          </Typography>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Card>
              </Grid>
              <Grid item lg={3} md={3} sm={12} xs={12}>
                <Card
                  className={classes.stepperCard}
                  sx={{ minHeight: "150px" }}
                >
                  <Grid container spacing={1}>
                    <Grid item lg={12} md={12} sm={12} xs={12} pt={2}>
                      <Grid
                        container
                        justifyContent={"space-between"}
                        spacing={5}
                        sx={{ borderBottom: 2, padding: 2 }}
                        className={classes.titleGrid}
                      >
                        <Grid
                          item
                          lg={12}
                          md={12}
                          sm={12}
                          xs={12}
                          pt={2}
                          alignContent={"center"}
                        >
                          <Typography variant="subtitle1">
                            <span className={classes.customerDetails}>
                              Looping :
                            </span>{" "}
                          </Typography>
                        </Grid>
                      </Grid>
                    </Grid>

                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <Grid
                        container
                        justifyContent="center"
                        alignItems="center"
                        spacing={5}
                        sx={{ px: 2 }}
                        className={classes.titleGrid}
                      >
                        <Grid
                          item
                          lg={12}
                          md={12}
                          sm={12}
                          xs={12}
                          container
                          justifyContent="center"
                          alignItems="center"
                          direction="column"
                          textAlign="center"
                        >
                          <Typography variant="subtitle1">
                            {product?.productDetailsIsLooping ? (
                              <CheckRoundedIcon
                                color="success"
                                sx={{
                                  fontSize: "42px",
                                  // backgroundColor: "red",
                                  // borderRadius: "50%",
                                }}
                              />
                            ) : (
                              <ClearRoundedIcon
                                color="error"
                                sx={{
                                  fontSize: "42px",
                                  // backgroundColor: "red",
                                  // borderRadius: "50%",
                                }}
                              />
                            )}
                          </Typography>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Card>
              </Grid>
            </Grid>
          </Grid> */}

{/* <Grid container spacing={2} >
   {cardsData.map((card, index) => (
    <Grid item xs={12} sm={6} md={2.4} onClick={() => setSelectedCard(card.title)}  sx={{ cursor: "pointer" }}>
      <Card className={classes.stepperCard} sx={{ minHeight: "150px" }}>
        <Grid container spacing={3}>
          <Grid item xs={12} pt={2}>
            <Grid container justifyContent="space-between" spacing={5} sx={{ borderBottom: 2, p: 2 }} className={classes.titleGrid}>
              <Grid item xs={12} pt={2} alignContent="center">
                <Typography variant="subtitle1">
                  <span className={classes.customerDetails}>{card.title} :</span>
                </Typography>
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12}>
            <Grid container justifyContent="center" alignItems="center" spacing={5} sx={{ px: 2 }} className={classes.titleGrid}>
              <Grid item xs={12} container justifyContent="center" alignItems="center" direction="column" textAlign="center">
               <Typography variant="subtitle1"  sx={{ fontSize: "25px", color:  card.title === "Modifier Group" && Array.isArray(card.value) && card.value.length > 0
        ? "success.main"
        : "error.main",
  }}
>
                {card.title === "Modifier Group"
              ? (Array.isArray(card.value) ? card.value.filter((selection: any) =>
          modifierGroupList.some(group => group.id === selection.modifierGroupId)
        ).length : 0)
                     : (card.value ? (
                    <CheckRoundedIcon color="success" sx={{ fontSize: "42px" }} />
                  ) : (
                    <ClearRoundedIcon color="error" sx={{ fontSize: "42px" }} />
                  ))
  }
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Card>
    </Grid>
  ))}
     */}





  <Grid container spacing={2} >
    {cardsData.map((card, index) => (
    <Grid
      item
      xs={12}
      sm={6}
      md={3}
      onClick={() => {
        if (card.title === "POS" || card.title === "Online" || card.title === "Food") return;
  setSelectedCard(card.title);
  if (card.title === "Modifier Grp") {
    setViewMode("groupList"); // reset to group list whenever Modifier Grp tab is clicked
    setActiveGroup(null);      // optional: clear any previously active group
  }
    if (card.title === "Bookings") {
      setActiveCard(null);
    }

}}

      
      sx={{ cursor:
      card.title === "POS" || card.title === "Online"
      ? "default"
      : "pointer",}}
      key={card.title}
    >
      <Card sx={{ minHeight: "50px",  backgroundColor: selectedCard === card.title 
      ? (theme) => theme.palette.primary.main 
      : (theme) => theme.palette.cardAdd.bgColor,
    color: selectedCard === card.title ? "white" : "inherit", }}>
        <Grid container spacing={3}>
          <Grid item xs={12} pt={2} >
            <Grid
              container
              justifyContent="space-between"
              spacing={5}
              sx={{ borderBottom: 2, p: 2 }}
              className={classes.titleGrid}
            >
              <Grid
                item
                xs={12}
                pt={2}
                display="flex"
                alignItems="center"
                justifyContent="flex-start"
              >
                {/* Icon */}
                {cardIcons[card.title] && (
                  <Box sx={{ display: "flex", alignItems: "center", mr: 1 }}>
                    {cardIcons[card.title]} 
                  </Box>
                )}
                {/* Title */}
                

              <Typography variant="subtitle1"  sx={{
                 lineHeight: "1.5",
                 marginBottom: "0px",
                 display: "flex",
                 alignItems: "center",
                 gap: 0.5,
               }}>
                  <span className={classes.customerDetails}>{card.title}  {card.title === "Stock" ? `(${totalStock})` : ""}</span>
                  {card.title === "Sales" ? `(${soldList?.reduce(
  (sum, item) => sum + Number(item.quantity || 0),
  0
) ?? 0})` : ""}
 {card.title === "Bookings" ? `(${product?.sold_quantity ?? 0})` : null}

 {card.title === "POS" &&
      (product?.viewPos ? (
        <CheckCircleIcon color="success" fontSize="small" />
      ) : (
        <CancelIcon color="error" fontSize="small" />
      ))}

    {/* Online status icon */}
    {card.title === "Online" &&
      (product?.viewOnline ? (
        <CheckCircleIcon color="success" fontSize="small" />
      ) : (
        <CancelIcon color="error" fontSize="small" />
      ))}

       {card.title === "Food" &&
      (product?.includes_food ? (
        <CheckCircleIcon color="success" fontSize="small" />
      ) : (
        <CancelIcon color="error" fontSize="small" />
      ))}
                  
               
                </Typography>
              </Grid>
            </Grid>
          </Grid>

          {/* <Grid item xs={12}>
            <Grid container justifyContent="center" alignItems="center" spacing={5} sx={{ px: 2 }} className={classes.titleGrid}>
              <Grid item xs={12} container justifyContent="center" alignItems="center" direction="column" textAlign="center">
               <Typography variant="subtitle1"  sx={{ fontSize: "25px", color:  card.title === "Modifier Group" && Array.isArray(card.value) && card.value.length > 0
        ? "success.main"
        : "error.main",
  }}
>
                {card.title === "Modifier Group"
              ? (Array.isArray(card.value) ? card.value.filter((selection: any) =>
          modifierGroupList.some(group => group.id === selection.modifierGroupId)
        ).length : 0)
                     : (card.value ? (
                    <CheckRoundedIcon color="success" sx={{ fontSize: "42px" }} />
                  ) : (
                    <ClearRoundedIcon color="error" sx={{ fontSize: "42px" }} />
                  ))
  }
                </Typography>
              </Grid>
            </Grid>
          </Grid> */}
        </Grid>
      </Card>
    </Grid>
  ))}
</Grid> 
          
</Grid>
          {/* <Grid item lg={12} md={12} sm={12} xs={12}>
            <Card className={classes.stepperCard}>
              <Grid container spacing={1} pb={5}>
                <Grid item lg={12} md={12} sm={12} xs={12} pt={2}>
                  <Grid
                    container
                    justifyContent={"space-between"}
                    spacing={5}
                    sx={{ borderBottom: 2, padding: 2 }}
                    className={classes.titleGrid}
                  >
                    <Grid
                      item
                      lg={12}
                      md={12}
                      sm={12}
                      xs={12}
                      pt={2}
                      alignContent={"center"}
                    >
                      <Typography variant="subtitle1">
                        <span className={classes.customerDetails}>
                          {product?.productName}
                        </span>{" "}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Grid
                    container
                    justifyContent={"space-between"}
                    spacing={5}
                    sx={{ px: 2 }}
                    className={classes.titleGrid}
                  >
                    <Grid
                      item
                      lg={12}
                      md={12}
                      sm={12}
                      xs={12}
                      alignContent={"center"}
                      direction={"column"}
                    >
                      <Typography variant="subtitle1">
                        <span className={classes.customerDetails}>
                          Product Name :
                        </span>{" "}
                        {product?.productName}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Grid
                    container
                    justifyContent={"space-between"}
                    spacing={5}
                    sx={{ px: 2 }}
                    className={classes.titleGrid}
                  >
                    <Grid
                      item
                      lg={12}
                      md={12}
                      sm={12}
                      xs={12}
                      alignContent={"center"}
                      direction={"column"}
                    >
                      <Typography variant="subtitle1">
                        <span className={classes.customerDetails}>
                          Product Category :
                        </span>{" "}
                        {categoryMap.get(product?.productCategoryId) || ""}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Grid
                    container
                    justifyContent={"space-between"}
                    spacing={5}
                    sx={{ px: 2 }}
                    className={classes.titleGrid}
                  >
                    <Grid
                      item
                      lg={12}
                      md={12}
                      sm={12}
                      xs={12}
                      alignContent={"center"}
                      direction={"column"}
                    >
                      <Typography variant="subtitle1">
                        <span className={classes.customerDetails}>
                          Product Brand :
                        </span>{" "}
                        {productBrandMap.get(product?.productBrandId) || ""}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Grid
                    container
                    justifyContent={"space-between"}
                    spacing={5}
                    sx={{ px: 2 }}
                    className={classes.titleGrid}
                  >
                    <Grid
                      item
                      lg={12}
                      md={12}
                      sm={12}
                      xs={12}
                      alignContent={"center"}
                      direction={"column"}
                    >
                      <Typography variant="subtitle1">
                        <span className={classes.customerDetails}>
                          Product Tag :
                        </span>{" "}
                        {(product?.productTagIds || [])
                          .map((tagId) => productTagMap.get(tagId) || "")
                          .join(", ")}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Grid
                    container
                    justifyContent={"space-between"}
                    spacing={5}
                    sx={{ px: 2 }}
                    className={classes.titleGrid}
                  >
                    <Grid
                      item
                      lg={12}
                      md={12}
                      sm={12}
                      xs={12}
                      alignContent={"center"}
                      direction={"column"}
                    >
                      <Typography variant="subtitle1">
                        <span className={classes.customerDetails}>
                          Conversion unit :
                        </span>{" "}
                        {product?.productConversionUnit
                          ?.map((unit) => {
                            const unitLabel = Object.keys(SizeOfLevelType).find(
                              (key) =>
                                SizeOfLevelType[
                                  key as keyof typeof SizeOfLevelType
                                ] === unit
                            );
                            return unitLabel;
                          })
                          .join(", ") || " "}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Grid
                    container
                    justifyContent={"space-between"}
                    spacing={5}
                    sx={{ px: 2 }}
                    className={classes.titleGrid}
                  >
                    <Grid
                      item
                      lg={12}
                      md={12}
                      sm={12}
                      xs={12}
                      alignContent={"center"}
                      direction={"column"}
                    >
                      <Typography variant="subtitle1">
                        <span className={classes.customerDetails}>
                          Printers :
                        </span>{" "}
                        {(product?.productPrinterIds || [])
                          .map((tagId) => ProductPrinterMap.get(tagId) || "")
                          .join(", ")}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Grid
                    container
                    justifyContent={"space-between"}
                    spacing={5}
                    sx={{ px: 2 }}
                    className={classes.titleGrid}
                  >
                    <Grid
                      item
                      lg={12}
                      md={12}
                      sm={12}
                      xs={12}
                      alignContent={"center"}
                      direction={"column"}
                    >
                      <Typography variant="subtitle1">
                        <span className={classes.customerDetails}>
                          Short Description :
                        </span>{" "}
                        {product?.productShortDescription}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Card>
          </Grid> */}


    


          {selectedCard === "Bookings" && (

     <> 
       <Grid item lg={12} md={12} sm={12} xs={12}>
          
     
     <Grid container spacing={2} >
       {[ // array of your 5 cards
         { title: 'Sold', value: product?.sold_quantity, prefix: '', suffix: '' },
         { title: 'Available', value: (product?.qty ?? 0) - (product?.sold_quantity ?? 0), prefix: '', suffix: '' },
         { title: 'Max Participants', value: product?.qty, prefix: '', suffix: '' },
         { title: 'Expected Participants', value: product?.expecting_participants, prefix: '', suffix: '' },
        //  { title: 'Total Clients', value: totalClients, prefix: '', suffix: '' }
       ].map((item) => (
         <Grid item xs={12} sm={6} md={3} key={item.title}>
           <Card elevation={3}   onClick={() => {
          setActiveCard(item.title as any);
         switch (item.title) {
      case "Stock":
        if (stockHistory.length === 0) fetchStockHistory();
        break;
      case "Inv Cost":
        if (invCostHistory.length === 0) fetchInvCostHistory();
        break;
      case "Cost":
        if (costHistory.length === 0) fetchCostHistory();
        break;
      case "Selling Price":
        if (sellingPriceHistory.length === 0) fetchSellingPriceHistory();
        break;
    }
  }}
        sx={{
          cursor: "pointer",
          border:
            activeCard === item.title
              ? "2px solid #4CAF50"
              : "1px solid #eee",
          transition: "0.2s",
        }}>
             <CardContent>
               <Grid container direction="column" alignItems="center">
                 <Typography variant="h5" mt={2}>{item.title}</Typography>
                 <Typography
                   variant="h3"
                   sx={{ marginTop: 2, fontWeight: "bold", color: "#4CAF50" }}
                 >
                   {item.prefix}{item.value}{item.suffix}
                 </Typography>
               </Grid>
             </CardContent>
           </Card>
         </Grid>
       ))}
     </Grid>

     </Grid>






     {activeCard === "Stock" && (
       <Grid item lg={12} md={12} sm={12} xs={12}>
  <Card className={classes.card} sx={{ mt: 3 }}>
    <Grid
                    container
                    justifyContent={"space-between"}
                    spacing={5}
                    sx={{ borderBottom: 2, padding: 2 }}
                    className={classes.titleGrid}
                  >
  
     <Grid item lg={4} md={4} sm={4} xs={4} pt={2} alignContent={"center"}>
          <Typography className={classes.cardTitle}>
            Stock History
          </Typography>
        </Grid>
          <Grid
                item
                lg={8}
                md={8}
                sm={8}
                xs={8}
                sx={{ display: "flex", justifyContent: "flex-end" }}
              >
                <Grid
                  container
                  spacing={1}
                  justifyContent="flex-end"
                  sx={{ display: "flex" }}
                >
                  {!product?.isSerialize && (
                   <Grid item>
                                <Button
                                  variant="outlined"
                                  className={classes.addButton}
                                  onClick={() => setOpenManualModal(true)}
                                >
                                  Edit Stock
                                </Button>
                              </Grid>
                              )}

                </Grid>
                  </Grid>
                        </Grid>
 
    {loading ? (
        <Typography>Loading...</Typography>
      ) : (
      <Timeline position="alternate">
        {stockHistory.map((row, index) => (
          <TimelineItem key={index}>
            <TimelineOppositeContent color="text.secondary" sx={{ fontSize: 12 }}>
              {dayjs(row.date).format("DD-MMM-YY, hh:mm A")}
            </TimelineOppositeContent>

            <TimelineSeparator>
              <TimelineDot color={row.qty > 0 ? "success" : "error"} />
              {index !== stockHistory.length - 1 && <TimelineConnector />}
            </TimelineSeparator>

            <TimelineContent>
              <Typography sx={{ fontWeight: 600, color: row.qty > 0 ? "green" : "red" }}>
                {row.qty > 0 ? `+${row.qty}` : row.qty} ({row.type})
              </Typography>
              <Typography variant="body2">Balance: {row.balance}</Typography>
              <Typography variant="body2">Ref: {row.reference}</Typography>
               {row.updated_by && (
    <Typography variant="body2" >
      Updated by: {row.updated_by}
    </Typography>
  )}
            </TimelineContent>
          </TimelineItem>
        ))}
      </Timeline>
            )}

 
  </Card>
  </Grid>
)}

{activeCard === "Inv Cost" && (
    <Grid item lg={12} md={12} sm={12} xs={12}>
  <Card className={classes.card} sx={{ mt: 3 }}>
<Grid
        container
        justifyContent={"space-between"}
        spacing={5}
        sx={{ borderBottom: 2, padding: 2 }}
        className={classes.titleGrid}
      >
        <Grid item lg={4} md={4} sm={4} xs={4} pt={2} alignContent={"center"}>
          <Typography className={classes.cardTitle}>
            Inventory Cost History
          </Typography>
        </Grid>
     
        <Grid
                item
                lg={8}
                md={8}
                sm={8}
                xs={8}
                sx={{ display: "flex", justifyContent: "flex-end" }}
              >
                <Grid
                  container
                  spacing={1}
                  justifyContent="flex-end"
                  sx={{ display: "flex" }}
                >

                </Grid>
                  </Grid>
                        </Grid>
                      

      {loading ? (
        <Typography>Loading...</Typography>
      ) : (
        <TableContainer>
        <Table className={classes.table}>
            <TableHead className={classes.tableHeaderRow}>
              <TableRow>
                <TableCell className={classes.tablheader}> <strong>Date</strong></TableCell>
                <TableCell className={classes.tablheader}> <strong>Type</strong></TableCell>
                <TableCell className={classes.tablheader}> <strong>Cost</strong></TableCell>
                <TableCell className={classes.tablheader}> <strong>Reference</strong></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {invCostHistory.map((row, index) => (
                <TableRow key={index}>
                  <TableCell className={classes.tablCell}>{dayjs(row.date).format("DD-MMM-YY, hh:mm A")}</TableCell>
                  <TableCell className={classes.tablCell}>{row.type}</TableCell>
                  <TableCell className={classes.tablCell}>${row.value.toFixed(2)}</TableCell>
                  <TableCell className={classes.tablCell}>{row.reference}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}

  </Card>
  </Grid>
)}


{activeCard === "Cost" && (
  <Grid item lg={12} md={12} sm={12} xs={12}>
  <Card className={classes.card} sx={{ mt: 3 }}>
    <Grid
                    container
                    justifyContent={"space-between"}
                    spacing={5}
                    sx={{ borderBottom: 2, padding: 2 }}
                    className={classes.titleGrid}
                  >
  
     <Grid item lg={4} md={4} sm={4} xs={4} pt={2} alignContent={"center"}>
          <Typography className={classes.cardTitle}>
            Cost History
          </Typography>
        </Grid>
          <Grid
                item
                lg={8}
                md={8}
                sm={8}
                xs={8}
                sx={{ display: "flex", justifyContent: "flex-end" }}
              >
                <Grid
                  container
                  spacing={1}
                  justifyContent="flex-end"
                  sx={{ display: "flex" }}
                >

                </Grid>
                  </Grid>
                        </Grid>

      {loading ? (
        <Typography>Loading...</Typography>
      ) : (
        <TableContainer>
          <Table  className={classes.table}>
            <TableHead className={classes.tableHeaderRow}>
              <TableRow>
                <TableCell className={classes.tablheader}><strong>Date</strong></TableCell>
                <TableCell className={classes.tablheader}><strong>Type</strong></TableCell>
                <TableCell className={classes.tablheader}><strong>Cost</strong></TableCell>
                <TableCell className={classes.tablheader}><strong>Reference</strong></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {costHistory.map((row, index) => (
                <TableRow key={index}>
                  <TableCell className={classes.tablCell}>{dayjs(row.date).format("DD-MMM-YY, hh:mm A")}</TableCell>
                  <TableCell className={classes.tablCell}>{row.type}</TableCell>
                  <TableCell className={classes.tablCell} >${row.value.toFixed(2)}</TableCell>
                  <TableCell className={classes.tablCell}>{row.reference}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}

  </Card>
  </Grid>
)}


{activeCard === "Selling Price" && (
  <Grid item lg={12} md={12} sm={12} xs={12}>
  <Card className={classes.card} sx={{ mt: 3 }}>
    <Grid
                    container
                    justifyContent={"space-between"}
                    spacing={5}
                    sx={{ borderBottom: 2, padding: 2 }}
                    className={classes.titleGrid}
                  >
  
     <Grid item lg={4} md={4} sm={4} xs={4} pt={2} alignContent={"center"}>
          <Typography className={classes.cardTitle}>
            Selling Price History
          </Typography>
        </Grid>
          <Grid
                item
                lg={8}
                md={8}
                sm={8}
                xs={8}
                sx={{ display: "flex", justifyContent: "flex-end" }}
              >
                <Grid
                  container
                  spacing={1}
                  justifyContent="flex-end"
                  sx={{ display: "flex" }}
                >

                </Grid>
                  </Grid>
                        </Grid>

      {loading ? (
        <Typography>Loading...</Typography>
      ) : (
        <TableContainer>
          <Table  className={classes.table}>
            <TableHead className={classes.tableHeaderRow}>
              <TableRow>
                <TableCell className={classes.tablheader}><strong>Date</strong></TableCell>
                <TableCell className={classes.tablheader}><strong>Type</strong></TableCell>
                <TableCell className={classes.tablheader}><strong>Reg Price</strong></TableCell>
                <TableCell className={classes.tablheader}><strong>Sale Price</strong></TableCell>
                <TableCell className={classes.tablheader}><strong>Reference</strong></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {sellingPriceHistory.map((row, index) => (
                <TableRow key={index}>
                  <TableCell className={classes.tablCell}>{dayjs(row.date).format("DD-MMM-YY, hh:mm A")}</TableCell>
                  <TableCell className={classes.tablCell}>{row.type}</TableCell>
                <TableCell className={classes.tablCell}> {row.sellingPrice ? `$${row.sellingPrice}` : "-"}</TableCell>
               <TableCell className={classes.tablCell}> {row.offerPrice ? `$${row.offerPrice}` : "-"}</TableCell>

                  <TableCell className={classes.tablCell}>{row.reference}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
 
  </Card>
    </Grid>
)}


       
            
            { !activeCard && invoiceList?.length > 0 && (

          
            <Grid item lg={12} md={12} sm={12} xs={12}>
                <Card className={classes.card}>
                  <Grid
                    container
                    justifyContent={"space-between"}
                    spacing={5}
                    sx={{ borderBottom: 2, padding: 2 }}
                    className={classes.titleGrid}
                  >
                    <Grid item lg={4} md={4} sm={4} xs={4} pt={2} alignContent={"center"}>
                      <Typography className={classes.cardTitle}>Invoice</Typography>
                    </Grid>
                    <Grid
                      item
                      lg={8}
                      md={8}
                      sm={8}
                      xs={8}
                      sx={{ display: "flex", justifyContent: "flex-end" }}
                    >
                      <Grid
                        container
                        spacing={1}
                        justifyContent="flex-end"
                        sx={{ display: "flex" }}
                      >
                        <Grid item>
                          <TextField
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <CiSearch className={classes.searchWidgetIcon} />
          </InputAdornment>
        ),
        classes: {
          root: classes.formControlList,
        },
      }}
      fullWidth
      value={searchQueryStock}
      // onChange={(e) => setSearchQueryStock(e.target.value)}
      placeholder="Search .."
      sx={{ width: "100%" }}
      size="small"
    />
                        </Grid>




                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid>
                    <TableContainer>
                      <Table className={classes.table}>
                       <TableHead className={classes.tableHeaderRow}>
              <TableRow>
                {/* <TableCell className={classes.tablheader}>
                  <CustomCheckbox name="checkbox" />
                </TableCell> */}
                <TableCell className={classes.tablheader}>
                  <strong>#</strong>
                </TableCell>
                <TableCell className={classes.tablheader}>
                  <strong>Invoice Number</strong>
                </TableCell>
                {/* <TableCell className={classes.tablheader}>
                  <strong>Mode</strong>
                </TableCell> */}
                <TableCell className={classes.tablheader}>
                  <strong>Status</strong>
                </TableCell>
                 <TableCell className={classes.tablheader}>
                  <strong>Qty</strong>
                </TableCell>
                <TableCell className={classes.tablheader}>
                  <strong>Amount</strong>
                </TableCell>
                <TableCell className={classes.tablheader}>
                  <strong>Paid Amt</strong>
                </TableCell>
                <TableCell className={classes.tablheader}>
                  <strong>Balance</strong>
                </TableCell>
                

                {/* <TableCell className={classes.tablheader}>
                  <strong>Issue From</strong>
                </TableCell> */}
                <TableCell className={classes.tablheader}>
                  <strong>Issue For</strong>
                </TableCell>

                <TableCell className={classes.tablheader}>
                  <strong>Used</strong>
                </TableCell>
           
                {/* <TableCell className={classes.tablheader}>
                  <strong>Status</strong>
                </TableCell> */}
                <TableCell
                  className={classes.tablheader}
                   sx={{ textAlign: "right" ,'@media print': {
                      display: 'none',
                    } }}
                >
                  <strong>Actions</strong>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {isError || invoiceList.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={20} align="center">
                    {isError ? "Error fetching data" : "No data available"}
                  </TableCell>
                </TableRow>
              ) : (
                invoiceList
                  // .filter((row: IInvoice) => row.Mode !== 'POS')
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row: IInvoice, index) => {
                    const statusLabel = getStatusLabel(
                      row.quoteWorkOrderStatus
                    );
                    const statusColor = getStatusColor(
                      row.quoteWorkOrderStatus
                    );
                 
                    const balance = Math.max(0, parseFloat(row.quoteWorkOrderSaleGrandTotal || "0") - parseFloat(String(row.amount_paid || "0")));
                   
                    return (
                      <TableRow key={row.id} className={classes.tableRowHover}>
                        {/* <TableCell className={classes.tablCell}>
                          <CustomCheckbox name="checkbox" />
                        </TableCell> */}
                
                        <TableCell scope="row" className={classes.tablCell}>
                          {page * rowsPerPage + index + 1}
                        </TableCell>
                        <TableCell
  component="th"
  scope="row"
  className={classes.tablCell}
  sx={{ whiteSpace: "nowrap", cursor: "pointer" }} // Prevents line break & makes it clickable
  //onClick={() => navigate(`/work-order/history/${row.work_order_id}`)} // Use backticks
>
  <Link  to={`/work-order/history/${row.work_order_id}`} // Replace with the correct path to your desired page
  style={{ textDecoration: 'none', display:'flex', color: 'inherit',cursor: 'pointer', }} >
  
  {row.InvoiceNo}
    &nbsp;
 {/* <LinkIcon fontSize="small" /> */}
  </Link>
</TableCell>

{/* <TableCell scope="row" className={classes.tablCell}>
                          {row.Mode}
                        </TableCell> */}

                        <TableCell scope="row" className={classes.tablCell}>
                                               <Button
                                                                           className={classes.statusButtonList}
                                                                           style={{
                                                                             color: statusColor,
                                                                             backgroundColor: row.quoteWorkOrderStatus === WorkOrderStatus.Paid
                                                                             ? "#e1f8d5"
                                                                             : row.quoteWorkOrderStatus === WorkOrderStatus.Cancel
                                                                             ? "#f8d7da"
                                                                             : row.quoteWorkOrderStatus === WorkOrderStatus.Pending
                                                                             ? "lightyellow"
                                                                               : row.quoteWorkOrderStatus === WorkOrderStatus.Initiated
                                                                             ? "#e2fafa"
                                                                             : "#ffffff", // Fallback for other statuses
                                                                             border: "solid 1px",
                                                                             borderColor: statusColor,
                                                                             borderRadius: "8px",
                                                                             
                                                                           }}
                                                                         >
                                                                           {statusLabel}
                                                                         </Button>
                                             </TableCell>
                                              <TableCell>
  {row.quoteWorkOrderSale
   ?.filter(i => String(i.productId) === String(ProductId))
    ?.map((i) => `${i.quantity}`)
    .join(', ')
  }
</TableCell>

                        <TableCell
                          component="th"
                          scope="row"
                          className={classes.tablCell}
                        >
                            {"$"}
                                  {parseFloat(
                                    row.quoteWorkOrderSaleGrandTotal || "0"
                                  ).toFixed(2)}
                         
                        </TableCell>
                        <TableCell  component="th" scope="row"  className={classes.tablCell}>
                            {"$"}{(row.amount_paid || "0" )}
                        </TableCell>
                       
                        <TableCell component="th" scope="row" className={classes.tablCell}>
                         {"$"}{balance.toFixed(2)}
                         </TableCell>

                        

                        {/* <TableCell scope="row" className={classes.tablCell}>
                          {row.company.companyName || row.project.projectName || ""}
                       
                        </TableCell> */}
                        <TableCell scope="row" className={classes.tablCell}>
                          <Grid container>
                            <Grid item lg={12} md={12} sm={12} xs={12}>
                            {row.project?.projectName || row.customer?.customerCompanyName || ""}
                            </Grid>
                           <Grid item lg={12} md={12} sm={12} xs={12}>
                           
                    
                               <Link   
                        to={`/customer-history/${row.quoteWorkOrderCustomerId}`} // Replace with the correct path to your desired page
                        style={{ textDecoration: 'none', display:'flex', color: 'inherit',cursor: 'pointer', }} >
  
                            {`${row.customer?.customerFirstName?.charAt(0).toUpperCase() + row.customer?.customerFirstName?.slice(1).toLowerCase() || ""} 
${row.customer?.customerLastName?.charAt(0).toUpperCase() + row.customer?.customerLastName?.slice(1).toLowerCase() || ""}`}
                             &nbsp;
    {/* <LinkIcon fontSize="small" /> */}
      </Link>    
           
                            </Grid>
                          </Grid>
                        </TableCell>

                        <TableCell scope="row" className={classes.tablCell}>
 {row.order_tickets?.map(ticket => (
  <div> {ticket.used_quantity}</div>
))}

       </TableCell>              
                        {/* <TableCell scope="row" className={classes.tablCell}>
                          <Button
                            className={classes.statusButtonList}
                            style={{
                              color: statusColor,
                              border: "solid 1px",
                              borderColor: statusColor,
                              borderRadius: "8px",
                            }}
                          >
                            {statusLabel}
                          </Button>
                        </TableCell> */}
                        <TableCell scope="row" className={classes.tablCell}>
               
                          <Grid
                            container
                            spacing={1}
                            sx={{ display: "flex", justifyContent: "flex-end" }}
                          >
                              {row.order_tickets?.map((ticket) =>  {
                         
    const fullyUsed = ticket.used_quantity >= ticket.booked_quantity;
         return (
 <Grid item>
                         <Tooltip title={fullyUsed ? "Fully Scanned" : "Scan Ticket"}>
           <span>
          <Button
            variant="contained"   
            className={classes.viewButtonList}   
            onClick={() => !fullyUsed && window.open(`/scan/${ticket.qr_token}`, "_blank")}
            disabled={fullyUsed}
          >
            {fullyUsed ?  <CheckCircleIcon  sx={{ color: "#2e7d32" }} />  : <QrCodeScannerIcon />}
          </Button>
          </span>
        </Tooltip>
                      </Grid>  
                       );
  })}               
                             
                        
                           {/* <Grid item  sx={{ '@media print': {
                      display: 'none',
                    } }}>
                              <Button
                                variant="contained"
                                className={classes.viewButtonList}
                                onClick={() =>
                                  navigate(`/invoice/history/${row.id}`)
                                }
                              >
                                <DescriptionIcon 
                                  className={classes.viewListIcon}
                                />
                              </Button>
                            </Grid> */}

                              {/* <Grid item sx={{ '@media print': {
                    display: 'none',
                  } }}>
                        <Link   className={classes.viewButtonList}
                        to={`/work-order/history/${row.work_order_id}`} // Replace with the correct path to your desired page
                        style={{ textDecoration: 'none', color: 'inherit',cursor: 'pointer', }} // Optional: style to remove link styling
                      >
                         <VisibilitySharpIcon
                                  className={classes.viewListIcon}
                                />
                                              </Link>
                             
                            </Grid>

                           

                          <Grid item sx={{ '@media print': {
                    display: 'none',
                  } }}>
                          <Button
  variant="contained"
  className={classes.editButtonList}
  onClick={() =>
    navigate(
      row.project?.id
        ? `/invoice/project/edit/${row.id}` // Redirect to project-specific edit page
        : `/invoice/edit/${row.id}` // Redirect to regular edit page
    )
  }
>
  <EditSharpIcon className={classes.editListIcon} />
</Button>

</Grid> */}

                          
                          </Grid>
                        </TableCell>
                      </TableRow>
                    );
                  })
              )}
                        </TableBody>
                      </Table>
                      <Grid
                        spacing={5}
                        p={"18px"}
                        py={4}
                        justifyContent={"end"}
                        container
                        textAlign={"center"}
                        alignContent={"center"}
                        alignItems={"center"}
                      >
                        <Grid
                          sx={{
                            textAlign: "end",
                            justifyContent: "flex-end",
                            alignItems: "flex-end",
                          }}
                        >
                          <Pagination
      count={filteredSerializedList .length}
      page={page}
      rowsPerPage={rowsPerPage}
      onPageChange={handleChangePage}
    />
                        </Grid>
                      </Grid>
                    </TableContainer>
                    {openCreateVariantDialog && (
                      <CreateVariantPopUp
                        openModel={openCreateVariantDialog}
                        handleCloseDialog={handleCreateCloseDialog}
                        productId={String(ProductId)} />
                    )}
                    {selectedProduct && (
                      <EditVariantPopUp
                        openModel={openDialog}
                        handleCloseDialog={handleCloseDialog}
                        data={selectedProduct} />
                    )}
                    {productToDelete && (
                      <DeletePopup
                        open={openDeleteProduct}
                        handleCloseDelete={handleCloseDeletePopup}
                        onConfirm={async () => {
                          await handleDelete(productToDelete.id.toString());
                        } }
                        title="Delete Product"
                        content={`Are you sure you want to delete "${productToDelete.productName}"?`} />
                    )}
                  </Grid>
                </Card>


              </Grid>
                )}
              
              </>

      )}  


        {selectedCard === "Sales" && (
          <Grid item lg={12} md={12} sm={12} xs={12}>
   <Card className={classes.card}>
      <Grid
        container
        justifyContent={"space-between"}
        spacing={5}
        sx={{ borderBottom: 2, padding: 2 }}
        className={classes.titleGrid}
      >
        <Grid item lg={4} md={4} sm={4} xs={4} pt={2} alignContent={"center"}>
          <Typography className={classes.cardTitle}>Sales  {/* ({soldList?.length}) */} </Typography>
        </Grid>
        <Grid
          item
          lg={8}
          md={8}
          sm={8}
          xs={8}
          sx={{ display: "flex", justifyContent: "flex-end" }}
        >
          <Grid
            container
            spacing={1}
            justifyContent="flex-end"
            sx={{ display: "flex" }}
          >
            <Grid item>
              <TextField
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <CiSearch className={classes.searchWidgetIcon} />
                    </InputAdornment>
                  ),
                  classes: {
                    root: classes.formControlList,
                  },
                }}
                fullWidth
                value={searchQuerySale}
                onChange={(e) => setSearchQuerySale(e.target.value)}
                placeholder="Invoice No .."
                sx={{ width: "100%" }}
                size="small"
              />
            </Grid>

          

           
          </Grid>
        </Grid>
      </Grid>

      <Grid>
        <TableContainer>
          <Table className={classes.table}>
            <TableHead className={classes.tableHeaderRow}>
              <TableRow>
                {/* <TableCell className={classes.tablheader}>
                  <CustomCheckbox name="checkbox" />
                </TableCell> */}
                <TableCell className={classes.tablheader}>
                  <strong>#</strong>
                </TableCell>
                 <TableCell className={classes.tablheader}>
                  <strong>Invoice No</strong>
                </TableCell>
                     <TableCell className={classes.tablheader}>
                  <strong>Sold From</strong>
                </TableCell>
                {/* <TableCell className={classes.tablheader}>
                  <strong>Serial No</strong>
                </TableCell>
                <TableCell className={classes.tablheader}>
                  <strong>IMEI No</strong>
                </TableCell>
                  <TableCell className={classes.tablheader}>
                  <strong>Model No</strong>
                </TableCell> */}
                  {/* <TableCell className={classes.tablheader}>
                  <strong>Buy price</strong>
                </TableCell> */}
                 <TableCell className={classes.tablheader}>
                  <strong>Selling price</strong>
                </TableCell>
                 <TableCell className={classes.tablheader}>
                  <strong>qty</strong>
                </TableCell>
                  {/* <TableCell className={classes.tablheader}>
                  <strong>Vendor</strong>
                </TableCell>
             */}
                 <TableCell className={classes.tablheader}>
                  <strong>Customer</strong>
                </TableCell>
                 <TableCell className={classes.tablheader}>
                  <strong>Sold Date</strong>
                </TableCell>
                <TableCell className={classes.tablheader}>
  <strong>Serialized</strong>
</TableCell>

                {/* <TableCell className={classes.tablheader} sx={{textAlign: "right"}}>
                  <strong>Actions</strong>
                </TableCell> */}
              </TableRow>
            </TableHead>
            <TableBody>
              {isError || soldList.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={20} align="center">
                    {isError ? "Error fetching data" : "No data available"}
                  </TableCell>
                </TableRow>
              ) : (
                soldList
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row: ISold, index) => (
                    <TableRow key={row.id} className={classes.tableRowHover}>
                      <TableCell scope="row" className={classes.tablCell}>
                        {page * rowsPerPage + index + 1}
                      </TableCell>
                       <TableCell
                        component="th"
                        scope="row"
                        className={classes.tablCell}
                      >
                        {row.invoiceNo}
                        
                      </TableCell>
                          <TableCell
                        component="th"
                        scope="row"
                        className={classes.tablCell}
                      >{row.soldFrom}</TableCell>
                      {/* <TableCell
                        component="th"
                        scope="row"
                        className={classes.tablCell}
                      >
                        {row.SERIALNO}
                      </TableCell>
                     <TableCell
                        component="th"
                        scope="row"
                        className={classes.tablCell}
                      >
                        {row.imei}
                      </TableCell>
                       <TableCell
                        component="th"
                        scope="row"
                        className={classes.tablCell}
                      >
                        {row.modelNo}
                          </TableCell> */}
                           {/* <TableCell
                        component="th"
                        scope="row"
                        className={classes.tablCell}
                      >{row.buyingPrice}</TableCell> */}
                       <TableCell
                        component="th"
                        scope="row"
                        className={classes.tablCell}
                      >{row.sellingPrice}</TableCell>
                       <TableCell
                        component="th"
                        scope="row"
                        className={classes.tablCell}
                      >{row.quantity}</TableCell>
                      {/* <TableCell
                        component="th"
                        scope="row"
                        className={classes.tablCell}
                      >{row.vendorName}</TableCell> */}
                     <TableCell component="th" scope="row" className={classes.tablCell}>
  {row.customerId !== 0 ? (
    <Link
      to={`/customer-history/${row.customerId}`}
      style={{
        textDecoration: 'none',
        display: 'flex',
        color: 'inherit',
        cursor: 'pointer',
      }}
    >
      {row.customerName}
      <LinkIcon fontSize="small" />
    </Link>
  ) : (
    <span>{row.customerName}</span>
  )}
</TableCell>

                          <TableCell
                        component="th"
                        scope="row"
                        className={classes.tablCell}
                      >  {moment(row.created_at).format("DD-MMM-YY ")}
                        {/* {new Date(row.created_at).toLocaleDateString()} */}
                        </TableCell>
                 
                          
                         <TableCell component="th" scope="row" className={classes.tablCell}>
   {row.SERIALNO ? (
    <Button
  variant="outlined"
  size="small"
  onClick={() => {
    // find the serialized item in stock
    const found = serializedList.find(
      (s) =>
        s.SERIALNO === row.SERIALNO ||
        s.IMEInO === row.imei ||
        s.modelNo === row.modelNo
    );
    setSelectedSerialized(found ?? null);
    setOpenSerialized(true);
  }}
>
  View
</Button>

  ) : (
    "-"
  )}
</TableCell>

                       
                      <TableCell scope="row" className={classes.tablCell}>
                        <Grid
                          container
                          spacing={1}
                          sx={{ display: "flex", justifyContent: "flex-end" }}
                        >
                         
                        </Grid>
                      </TableCell>
                    </TableRow>
                  ))
              )}
            </TableBody>
          </Table>
          <Grid
            spacing={5}
            p={"18px"}
            py={4}
            justifyContent={"end"}
            container
            textAlign={"center"}
            alignContent={"center"}
            alignItems={"center"}
          >
            <Grid
              sx={{
                textAlign: "end",
                justifyContent: "flex-end",
                alignItems: "flex-end",
              }}
            >
              {/* <Pagination
                count={coursings.length}
                page={page}
                rowsPerPage={rowsPerPage}
                onPageChange={handleChangePage}
              /> */}
            </Grid>
          </Grid>
        </TableContainer>
     
      </Grid>
    </Card>

            
          </Grid>

      )}  


{selectedCard === "Variant" && (
          <Grid item lg={12} md={12} sm={12} xs={12}>
   <Card className={classes.card}>
      <Grid
        container
        justifyContent={"space-between"}
        spacing={5}
        sx={{ borderBottom: 2, padding: 2 }}
        className={classes.titleGrid}
      >
        <Grid item lg={4} md={4} sm={4} xs={4} pt={2} alignContent={"center"}>
          <Typography className={classes.cardTitle}>New Variant</Typography>
        </Grid>
        <Grid
          item
          lg={8}
          md={8}
          sm={8}
          xs={8}
          sx={{ display: "flex", justifyContent: "flex-end" }}
        >
          <Grid
            container
            spacing={1}
            justifyContent="flex-end"
            sx={{ display: "flex" }}
          >
            <Grid item>
          
            </Grid>

            <Grid item>
              <Button
                variant="contained"
                className={classes.addButton}
               onClick={handleCreateOpenDialog}
              >
                Add Variant
              </Button>
            </Grid>

           
          </Grid>
        </Grid>
      </Grid>

      <Grid>
        <TableContainer>
          <Table className={classes.table}>
            <TableHead className={classes.tableHeaderRow}>
              <TableRow>
              
                <TableCell className={classes.tablheader}>
                  <strong>#</strong>
                </TableCell>
                <TableCell className={classes.tablheader}>
                  <strong>Variant Name</strong>
                </TableCell>
                <TableCell className={classes.tablheader}>
                  <strong>Price</strong>
                </TableCell>
                  <TableCell className={classes.tablheader}>
                  <strong>Order</strong>
                </TableCell>
                 <TableCell className={classes.tablheader}>
                  <strong>Active</strong>
                </TableCell>
                <TableCell className={classes.tablheader} sx={{textAlign: "right"}}>
                  <strong>Actions</strong>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {isError || coursings.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={20} align="center">
                    {isError ? "Error fetching data" : "No data available"}
                  </TableCell>
                </TableRow>
              ) : (
                coursings
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row: IVariantPopUP, index) => (
                    <TableRow key={row.id} className={classes.tableRowHover}>
                      <TableCell scope="row" className={classes.tablCell}>
                        {page * rowsPerPage + index + 1}
                      </TableCell>
                      <TableCell
                        component="th"
                        scope="row"
                        className={classes.tablCell}
                      >
                        {row.productName}
                      </TableCell>
                     <TableCell
                        component="th"
                        scope="row"
                        className={classes.tablCell}
                      >
                        {row.productPrice}
                      </TableCell>
                       <TableCell
                        component="th"
                        scope="row"
                        className={classes.tablCell}
                      >
                        {row.orderNumber}
                          </TableCell>
                        <TableCell scope="row" className={classes.tablCell}>
                                              {row.isActive ? "Active" : "Inactive"}
                                            </TableCell>
                      <TableCell scope="row" className={classes.tablCell}>
                        <Grid
                          container
                          spacing={1}
                          sx={{ display: "flex", justifyContent: "flex-end" }}
                        >
                          <Grid item>
                            <Button
                              variant="contained"
                              className={classes.editButtonList}
                              onClick={() => handleOpenDialog(row)}
                            >
                              <EditSharpIcon className={classes.editListIcon} />
                            </Button>
                          </Grid>
                          <Grid item>
                            <Button
                              variant="contained"
                              className={classes.deleteButtonList}
                              onClick={() => handleOpenDeletePopup(row)}
                            >
                              <DeleteOutlineSharpIcon
                                className={classes.deleteListIcon}
                              />
                            </Button>
                          </Grid>
                        </Grid>
                      </TableCell>
                    </TableRow>
                  ))
              )}
            </TableBody>
          </Table>
          <Grid
            spacing={5}
            p={"18px"}
            py={4}
            justifyContent={"end"}
            container
            textAlign={"center"}
            alignContent={"center"}
            alignItems={"center"}
          >
            <Grid
              sx={{
                textAlign: "end",
                justifyContent: "flex-end",
                alignItems: "flex-end",
              }}
            >
             
            </Grid>
          </Grid>
        </TableContainer>
        {openCreateVariantDialog && (
          <CreateVariantPopUp
            openModel={openCreateVariantDialog}
            handleCloseDialog={handleCreateCloseDialog}
            productId={String(ProductId)}
          />
        )}
         {selectedProduct && (
          <EditVariantPopUp
            openModel={openDialog}
            handleCloseDialog={handleCloseDialog}
            data={selectedProduct}
          />
        )}
        {productToDelete && (
          <DeletePopup
            open={openDeleteProduct}
            handleCloseDelete={handleCloseDeletePopup}
            onConfirm={async () => {
              await handleDelete(productToDelete.id.toString());
            }}
            title="Delete Product"
            content={`Are you sure you want to delete "${productToDelete.productName}"?`}
          />
        )}
      </Grid>
    </Card>

            
          </Grid>

      )}  




      {selectedCard === "Modifier Grp" && (
  <>
    {viewMode === "groupList" && (
      
          <Grid item lg={12} md={12} sm={12} xs={12}>
              <Card className={classes.card}>
                <Grid
                  container
                  justifyContent={"space-between"}
                  spacing={5}
                  sx={{ borderBottom: 2, padding: 2 }}
                  className={classes.titleGrid}
                >
                  <Grid item lg={4} md={4} sm={4} xs={4} pt={2} alignContent={"center"}>
                    <Typography className={classes.cardTitle}>Modifier Group</Typography>
                  </Grid>
                  <Grid
                    item
                    lg={8}
                    md={8}
                    sm={8}
                    xs={8}
                    sx={{ display: "flex", justifyContent: "flex-end" }}
                  >
                    <Grid
                      container
                      spacing={1}
                      justifyContent="flex-end"
                      sx={{ display: "flex" }}
                    >
                      <Grid item>
                      
                      </Grid>

                      <Grid item>
                      
                        <Button
                          variant="contained"
                          className={classes.addButton}
                          onClick={() => {
                            // setSelectedModifierGrpId(null);
                            // setModifierGrpDetails([]);  
                            setModifierGrpDetails(
  selectedModifierGrps.map((g, idx) => ({
    id: String(g.modifierGroupId ?? g.id), // convert to string
    minimum: g.minimum ?? 0,               // string or number is fine
    maximum: g.maximum ?? 0,
    modifiers: g.modifiers || [],
    modifierGroupName: g.modifierGroupName || "",
    order: g.order ?? idx + 1, 
  }))
);

  setSelectedModifierGrpIds(
    selectedModifierGrps.map((g) => String(g.modifierGroupId ?? g.id))
  );
                            setShowModifierGrpPopup(true);
                            setSearchText('');
                          } }
                        >
                          Add
                        </Button>

                    
                      </Grid>


                     <Grid item>
  <Button
    variant="outlined"
    className={classes.addButton}
    onClick={() => {
      // Prepare orderList from already added modifier groups
     setOrderList(
  selectedModifierGrps.map((g, idx) => ({
 //   id: g.id ? String(g.id) : `grp-${idx}`,
      id: String(g.modifierGroupId ?? g.id),
    modifierGroupId: g.modifierGroupId ? String(g.modifierGroupId) : `grp-${idx}`,
      order: g.order ?? idx + 1,
    modifierGroupName: g.modifierGroupName,
    minimum: g.minimum,
    maximum: g.maximum,
    modifiers: g.modifiers || [],
  }))
      .sort((a, b) => (a.order ?? 0) - (b.order ?? 0))
);

      setShowOrderPopup(true);
    }}
  >
    Change Layout
  </Button>
</Grid>



                    </Grid>
                  </Grid>
                </Grid>

                <Grid>
                  <TableContainer>
                    <Table className={classes.table}>
                      <TableHead className={classes.tableHeaderRow}>
                        <TableRow>
                      
                          <TableCell className={classes.tablheader}>
                            <strong>#</strong>
                          </TableCell>
                          <TableCell className={classes.tablheader}>
                            <strong>Modifier Group Name</strong>
                          </TableCell>
                         
                          <TableCell className={classes.tablheader}>
                            <strong> Count</strong>
                          </TableCell>
                        
                         <TableCell className={classes.tablheader}>
                            <strong> Minimum</strong>
                          </TableCell>
                           <TableCell className={classes.tablheader}>
                            <strong> Maximum</strong>
                          </TableCell>
                          

                          {/* <TableCell
                            className={classes.tablheader}
                            sx={{ textAlign: "right" }}
                          >
                            <strong>Actions</strong>
                          </TableCell> */}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {isError || selectedModifierGrps.length === 0 ? (
                          <TableRow>
                            <TableCell colSpan={20} align="center">
                              {isError ? "Error fetching data" : "No data available"}
                            </TableCell>
                          </TableRow>
                        ) : (
                           [...selectedModifierGrps]
    .sort((a, b) => Number(a.order) - Number(b.order))
     .map((savedGroup, idx) => {

              //  selectedModifierGrps.map((savedGroup, idx) => {
  const modifierGroupId = savedGroup.modifierGroupId ?? savedGroup.id; // fallback to id

  const groupDetails = modifierGrpList.find(
    (mg) => Number(mg.id) === Number(modifierGroupId)
  );
  if (!groupDetails) return null;



                            return (
                              <TableRow key={savedGroup.modifierGroupId} className={classes.tableRowHover}>
                                <TableCell scope="row" className={classes.tablCell}>{idx + 1}</TableCell>
                             <TableCell
  scope="row"
  className={classes.tablCell}
  onClick={() => {
    setActiveGroup(savedGroup); 
    setViewMode("modifierDetails");
  }}
  style={{ cursor: "pointer",display:'flex'}}
>
  {groupDetails.modifierGroupName} 
  <LinkIcon fontSize="small" />
  
</TableCell>

                            <TableCell scope="row" className={classes.tablCell}>
            {Array.isArray(savedGroup.modifiers) ? savedGroup.modifiers.length : 0}
          </TableCell>
            <TableCell scope="row" className={classes.tablCell}>
            {savedGroup.minimum}
          </TableCell>
            <TableCell scope="row" className={classes.tablCell}>
            {savedGroup.maximum}
          </TableCell>
            {/* <TableCell scope="row" className={classes.tablCell}>
            {savedGroup.order}
          </TableCell> */}
                           
                                {/* <TableCell scope="row" className={classes.tablCell}   sx={{ textAlign: "right" }}>
                                                                 <span>{Array.isArray(groupDetails.modifiers) ? groupDetails.modifiers.length : 0}</span>
                                                         </TableCell> */}
                                {/* <TableCell className={classes.tablCell}>
                                  <Grid
                                    container
                                    spacing={1}
                                    sx={{ display: "flex", justifyContent: "flex-end" }}
                                  >
                                    <Grid item>
                                      <Button
                                        variant="contained"
                                        className={classes.editButtonList}
                                        onClick={() => handleEditModifierGroup(savedGroup)}
                                      >
                                        <VisibilitySharpIcon className={classes.editListIcon} />
                                      </Button>
                                    </Grid>

                                    <Grid item>
                                      <Button
                                        variant="contained"
                                        className={classes.deleteButtonList}
                                        onClick={() => handleDeleteModifierGroup(savedGroup.modifierGroupId)}
                                      >
                                        <DeleteOutlineSharpIcon
                                          className={classes.deleteListIcon} />
                                      </Button>
                                    </Grid>
                                  </Grid>
                                </TableCell> */}
                              </TableRow>
                            );
                          })
                        )}
                      </TableBody>
                    </Table>
                   
                    <Grid
                      spacing={5}
                      p={"18px"}
                      py={4}
                      justifyContent={"end"}
                      container
                      textAlign={"center"}
                      alignContent={"center"}
                      alignItems={"center"}
                    >
                      <Grid
                        sx={{
                          textAlign: "end",
                          justifyContent: "flex-end",
                          alignItems: "flex-end",
                        }}
                      >
                    
                      </Grid>
                    </Grid>
                  </TableContainer>
                  {openCreateVariantDialog && (
                    <CreateVariantPopUp
                      openModel={openCreateVariantDialog}
                      handleCloseDialog={handleCreateCloseDialog}
                      productId={String(ProductId)} />
                  )}
                  {selectedProduct && (
                    <EditVariantPopUp
                      openModel={openDialog}
                      handleCloseDialog={handleCloseDialog}
                      data={selectedProduct} />
                  )}
                  {productToDelete && (
                    <DeletePopup
                      open={openDeleteProduct}
                      handleCloseDelete={handleCloseDeletePopup}
                      onConfirm={async () => {
                        await handleDelete(productToDelete.id.toString());
                      } }
                      title="Delete Product"
                      content={`Are you sure you want to delete "${productToDelete.productName}"?`} />
                  )}
                </Grid>
              </Card>


            </Grid>
    )}

    {viewMode === "modifierDetails" && activeGroup && (
               <Grid item lg={12} md={12} sm={12} xs={12}>
              <Card className={classes.card}>
                <Grid
                  container
                  justifyContent={"space-between"}
                  spacing={5}
                  sx={{ borderBottom: 2, padding: 2 }}
                  className={classes.titleGrid}
                >
                  <Grid item lg={4} md={4} sm={4} xs={4} pt={2} alignContent={"center"}>
                    <Typography className={classes.cardTitle}>{activeGroup?.modifierGroupName ?? ""}
</Typography>
                  </Grid>
                  <Grid
                    item
                    lg={8}
                    md={8}
                    sm={8}
                    xs={8}
                    sx={{ display: "flex", justifyContent: "flex-end" }}
                  >
                    <Grid
                      container
                      spacing={1}
                      justifyContent="flex-end"
                      sx={{ display: "flex" }}
                    >
                      <Grid item>
                    
               <Button
                variant="contained"
                className={classes.addButton}
                endIcon={<ArrowDropDownIcon />}
                onClick={(e) => setAnchorEl(e.currentTarget)}
              >
                Edit
              </Button>
                      </Grid>


                    </Grid>
                  </Grid>
                </Grid>

                <Grid>
                  <TableContainer>
                    <Table className={classes.table}>
                      <TableHead className={classes.tableHeaderRow}>
                        <TableRow>
                      
                          <TableCell className={classes.tablheader}>
                            <strong>#</strong>
                          </TableCell>
                          <TableCell className={classes.tablheader}>
                            <strong>Modifier Name</strong>
                          </TableCell>
                         
                          <TableCell className={classes.tablheader}>
                            <strong> Price</strong>
                          </TableCell>
                             <TableCell className={classes.tablheader}>
                            <strong> Online</strong>
                          </TableCell>
                             <TableCell className={classes.tablheader}>
                            <strong> POS</strong>
                          </TableCell>
                          <TableCell className={classes.tablheader}>
            <Checkbox
              checked={
                activeGroup?.modifiers &&
                activeGroup.modifiers.every((mod) => selectedRows[Number(mod.product_id)])
              }
              indeterminate={
                activeGroup?.modifiers &&
                activeGroup.modifiers.some((mod) => selectedRows[Number(mod.product_id)]) &&
                !activeGroup.modifiers.every((mod) => selectedRows[Number(mod.product_id)])
              }
              onChange={(e) => {
                const newSelected: Record<number, boolean> = {};
                if (e.target.checked && activeGroup?.modifiers) {
                  activeGroup.modifiers.forEach((mod) => {
                    newSelected[Number(mod.product_id)] = true;
                  });
                }
                setSelectedRows(newSelected);
              }}
            />
          </TableCell>
                        

                          {/* <TableCell
                            className={classes.tablheader}
                            sx={{ textAlign: "right" }}
                          >
                            <strong>Actions</strong>
                          </TableCell> */}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {isError || !activeGroup?.modifiers || activeGroup.modifiers.length === 0? (
                          <TableRow>
                            <TableCell colSpan={20} align="center">
                              {isError ? "Error fetching data" : "No data available"}
                            </TableCell>
                          </TableRow>
                        ) : (
                           activeGroup.modifiers?.map((mod, index) => (

                           
                              <TableRow key={mod.product_id} className={classes.tableRowHover}>
                                <TableCell scope="row" className={classes.tablCell}>{index + 1}</TableCell>
                                <TableCell scope="row" className={classes.tablCell}> {
    products?.find((p: any) => String(p.id) === String(mod.product_id))?.name ?? "Unnamed Product"
  }</TableCell>
                    <TableCell>
                  <TextField
                    type="number"
                    size="small"
                    value={mod.price ?? ""}
                    onChange={(e) => {
                      const updated = [...(activeGroup?.modifiers || [])];
                      updated[index] = { ...updated[index], price: Number(e.target.value) };
                      setActiveGroup({ ...activeGroup, modifiers: updated });
                    }}
                    sx={{ width: 100 }}
                  />
                </TableCell>
                <TableCell>
                  <IOSSwitch
                    checked={mod.online ?? false}
                    onChange={(e) => {
                      const updated = [...(activeGroup?.modifiers || [])];
                      updated[index] = { ...updated[index], online: e.target.checked };
                      setActiveGroup({ ...activeGroup, modifiers: updated });
                    }}
                  />
                </TableCell>
                <TableCell>
                  <IOSSwitch
                    checked={mod.pos ?? false}
                    onChange={(e) => {
                      const updated = [...(activeGroup?.modifiers || [])];
                      updated[index] = { ...updated[index], pos: e.target.checked };
                      setActiveGroup({ ...activeGroup, modifiers: updated });
                    }}
                  />
                </TableCell>
                <TableCell>
                  <Checkbox
                    checked={selectedRows[Number(mod.product_id)] || false}
                    onChange={(e) =>
                      setSelectedRows({
                        ...selectedRows,
                        [Number(mod.product_id)]: e.target.checked,
                      })
                    }
                  />
                </TableCell>
             
 
           
             
                                {/* <TableCell className={classes.tablCell}>
                                  <Grid
                                    container
                                    spacing={1}
                                    sx={{ display: "flex", justifyContent: "flex-end" }}
                                  >
                                    <Grid item>
                                      <Button
                                        variant="contained"
                                        className={classes.editButtonList}
                                        onClick={() => handleEditModifierGroup(savedGroup)}
                                      >
                                        <VisibilitySharpIcon className={classes.editListIcon} />
                                      </Button>
                                    </Grid>

                                    <Grid item>
                                      <Button
                                        variant="contained"
                                        className={classes.deleteButtonList}
                                        onClick={() => handleDeleteModifierGroup(savedGroup.modifierGroupId)}
                                      >
                                        <DeleteOutlineSharpIcon
                                          className={classes.deleteListIcon} />
                                      </Button>
                                    </Grid>
                                  </Grid>
                                </TableCell> */}
                              </TableRow>
                          ))
        )}
                      </TableBody>
                    </Table>


  <Grid item lg={12} md={12} sm={12} xs={12} pt={3}>
                  <Card className={classes.card}>
                    <Grid container spacing={3} p={"24px"}>
                      <Grid
                        item
                        lg={12}
                        md={12}
                        sm={12}
                        xs={12}
                        sx={{ display: "flex", justifyContent: "flex-end" }}
                      >
                        <Button
                          variant="outlined"
                        //  startIcon={<CloseIcon />}
                          className={classes.addButton}
                       //   onClick={cancelFunction}
                        >
                          Cancel
                        </Button>
                        <Box m={0.5}></Box>

                       <Button
    variant="contained"
    className={classes.addButton}
    color="primary"
    onClick={handleSaveModifierGrps}
  >
    Save
  </Button>

                      </Grid>
                    </Grid>
          </Card>
          
        </Grid>

                    
                   
                    <Grid
                      spacing={5}
                      p={"18px"}
                      py={4}
                      justifyContent={"end"}
                      container
                      textAlign={"center"}
                      alignContent={"center"}
                      alignItems={"center"}
                    >
                      <Grid
                        sx={{
                          textAlign: "end",
                          justifyContent: "flex-end",
                          alignItems: "flex-end",
                        }}
                      >
                    
                      </Grid>
                    </Grid>
                  </TableContainer>
                  {openCreateVariantDialog && (
                    <CreateVariantPopUp
                      openModel={openCreateVariantDialog}
                      handleCloseDialog={handleCreateCloseDialog}
                      productId={String(ProductId)} />
                  )}
                  {selectedProduct && (
                    <EditVariantPopUp
                      openModel={openDialog}
                      handleCloseDialog={handleCloseDialog}
                      data={selectedProduct} />
                  )}
                  {productToDelete && (
                    <DeletePopup
                      open={openDeleteProduct}
                      handleCloseDelete={handleCloseDeletePopup}
                      onConfirm={async () => {
                        await handleDelete(productToDelete.id.toString());
                      } }
                      title="Delete Product"
                      content={`Are you sure you want to delete "${productToDelete.productName}"?`} />
                  )}
                </Grid>
              </Card>


            </Grid>
    )}
  </>
)}



      {/* {selectedCard === 'Modifier Grp' && ( */}
          <>

          {/* <Grid item lg={12} md={12} sm={12} xs={12}>
              <Card className={classes.card}>
                <Grid
                  container
                  justifyContent={"space-between"}
                  spacing={5}
                  sx={{ borderBottom: 2, padding: 2 }}
                  className={classes.titleGrid}
                >
                  <Grid item lg={4} md={4} sm={4} xs={4} pt={2} alignContent={"center"}>
                    <Typography className={classes.cardTitle}>Modifier Group</Typography>
                  </Grid>
                  <Grid
                    item
                    lg={8}
                    md={8}
                    sm={8}
                    xs={8}
                    sx={{ display: "flex", justifyContent: "flex-end" }}
                  >
                    <Grid
                      container
                      spacing={1}
                      justifyContent="flex-end"
                      sx={{ display: "flex" }}
                    >
                      <Grid item>
                      
                      </Grid>

                      <Grid item>
                      
                        <Button
                          variant="contained"
                          className={classes.addButton}
                          onClick={() => {
                            setSelectedModifierGroupId(null);
                            setModifierGroupDetails(null);
                            setShowModifierGroupPopup(true);
                          } }
                        >
                          Add
                        </Button>

                      
                      </Grid>


                    </Grid>
                  </Grid>
                </Grid>

                <Grid>
                  <TableContainer>
                    <Table className={classes.table}>
                      <TableHead className={classes.tableHeaderRow}>
                        <TableRow>
                      
                          <TableCell className={classes.tablheader}>
                            <strong>#</strong>
                          </TableCell>
                          <TableCell className={classes.tablheader}>
                            <strong>Modifier Group Name</strong>
                          </TableCell>
                          
                          <TableCell className={classes.tablheader}  sx={{ textAlign: "left" }}>
                            <strong> Count</strong>
                          </TableCell>

                          
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {isError || modifierGrpList.length === 0 ? (
                          <TableRow>
                            <TableCell colSpan={20} align="center">
                              {isError ? "Error fetching data" : "No data available"}
                            </TableCell>
                          </TableRow>
                        ) : (
                          modifierGrpList
                          .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                           .map((row: IModifierGrpPopUp, index) => (
                              <TableRow key={row.id} className={classes.tableRowHover}>
                             <TableCell scope="row" className={classes.tablCell}>
                                                  {page * rowsPerPage + index + 1}
                                                </TableCell>
                                <TableCell scope="row" className={classes.tablCell}>{row.modifierGroupName}</TableCell>
                             <TableCell scope="row" className={classes.tablCell}   sx={{ textAlign: "left" }}>
                                                             <span>{Array.isArray(row.modifiers) ? row.modifiers.length : 0}</span>
                                                     </TableCell>
                               
                           
                            
                               
                              </TableRow>
                            ))
              )}
                        
                      </TableBody>
                    </Table>
              
                    <Grid
                      spacing={5}
                      p={"18px"}
                      py={4}
                      justifyContent={"end"}
                      container
                      textAlign={"center"}
                      alignContent={"center"}
                      alignItems={"center"}
                    >
                      <Grid
                        sx={{
                          textAlign: "end",
                          justifyContent: "flex-end",
                          alignItems: "flex-end",
                        }}
                      >
                       
                      </Grid>
                    </Grid>
                  </TableContainer>
                  {openCreateVariantDialog && (
                    <CreateVariantPopUp
                      openModel={openCreateVariantDialog}
                      handleCloseDialog={handleCreateCloseDialog}
                      productId={String(ProductId)} />
                  )}
                  {selectedProduct && (
                    <EditVariantPopUp
                      openModel={openDialog}
                      handleCloseDialog={handleCloseDialog}
                      data={selectedProduct} />
                  )}
                  {productToDelete && (
                    <DeletePopup
                      open={openDeleteProduct}
                      handleCloseDelete={handleCloseDeletePopup}
                      onConfirm={async () => {
                        await handleDelete(productToDelete.id.toString());
                      } }
                      title="Delete Product"
                      content={`Are you sure you want to delete "${productToDelete.productName}"?`} />
                  )}
                </Grid>
              </Card>


            </Grid> */}
          
          
          
          
          
        

{/* 
{selectedCard === "Modifier Grp" && viewMode === "modifierDetails" && activeGroup && (
      
            )}
             */}
            {/* <Grid item lg={12} md={12} sm={12} xs={12}>
                <Card className={classes.card}>
                  <Grid
                    container
                    justifyContent={"space-between"}
                    spacing={5}
                    sx={{ borderBottom: 2, padding: 2 }}
                    className={classes.titleGrid}
                  >
                    <Grid item lg={4} md={4} sm={4} xs={4} pt={2} alignContent={"center"}>
                      <Typography className={classes.cardTitle}>Linked Products</Typography>
                    </Grid>
                    <Grid
                      item
                      lg={8}
                      md={8}
                      sm={8}
                      xs={8}
                      sx={{ display: "flex", justifyContent: "flex-end" }}
                    >
                      <Grid
                        container
                        spacing={1}
                        justifyContent="flex-end"
                        sx={{ display: "flex" }}
                      >
                        <Grid item>
                        
                        </Grid>

                        <Grid item>
                        
                          <Button
                            variant="contained"
                            className={classes.addButton}
                            onClick={() => {
                              // setSelectedModifierGroupId(null);
                              // setModifierGroupDetails(null);
                             setShowLinkedProductPopup(true);
                            } }
                          >
                            Add
                          </Button>

                       
                        </Grid>


                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid>
                    <TableContainer>
                      <Table className={classes.table}>
                        <TableHead className={classes.tableHeaderRow}>
                          <TableRow>
                        
                            <TableCell className={classes.tablheader}>
                              <strong>#</strong>
                            </TableCell>
                            <TableCell className={classes.tablheader}>
                              <strong>Product Name</strong>
                            </TableCell>
                           
                            
                            <TableCell
                              className={classes.tablheader}
                              sx={{ textAlign: "right" }}
                            >
                              <strong>Actions</strong>
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {isError || linkedProducts.length === 0 ? (
                            <TableRow>
                              <TableCell colSpan={20} align="center">
                                {isError ? "Error fetching data" : "No data available"}
                              </TableCell>
                            </TableRow>
                          ) : (
                            linkedProducts.map((savedGroup, idx) => {
                              // find full modifier group details from master list
                                  const groupDetails = products.find(
        (p) => Number(p.id) === Number(savedGroup) // savedGroup is the ID
      );
      if (!groupDetails) return null;

                              return (
                                <TableRow key={savedGroup.linkedProductId} className={classes.tableRowHover}>
                                  <TableCell scope="row" className={classes.tablCell}>{idx + 1}</TableCell>
                                  <TableCell scope="row" className={classes.tablCell}>{groupDetails.productName}</TableCell>
                                 
                                 
                                  <TableCell className={classes.tablCell}>
                                    <Grid
                                      container
                                      spacing={1}
                                      sx={{ display: "flex", justifyContent: "flex-end" }}
                                    >
                                    
                                      <Grid item>
                                        <Button
                                          variant="contained"
                                          className={classes.deleteButtonList}
                                           onClick={() => handleDeleteLinkedProduct(savedGroup)}
                                        >
                                          <DeleteOutlineSharpIcon
                                            className={classes.deleteListIcon} />
                                        </Button>
                                      </Grid>
                                    </Grid>
                                  </TableCell>
                                </TableRow>
                              );
                            })
                          )}
                        </TableBody>
                      </Table>
                   
                      <Grid
                        spacing={5}
                        p={"18px"}
                        py={4}
                        justifyContent={"end"}
                        container
                        textAlign={"center"}
                        alignContent={"center"}
                        alignItems={"center"}
                      >
                        <Grid
                          sx={{
                            textAlign: "end",
                            justifyContent: "flex-end",
                            alignItems: "flex-end",
                          }}
                        >
                        
                        </Grid>
                      </Grid>
                    </TableContainer>
                    {openCreateVariantDialog && (
                      <CreateVariantPopUp
                        openModel={openCreateVariantDialog}
                        handleCloseDialog={handleCreateCloseDialog}
                        productId={String(ProductId)} />
                    )}
                    {selectedProduct && (
                      <EditVariantPopUp
                        openModel={openDialog}
                        handleCloseDialog={handleCloseDialog}
                        data={selectedProduct} />
                    )}
                    {productToDelete && (
                      <DeletePopup
                        open={openDeleteProduct}
                        handleCloseDelete={handleCloseDeletePopup}
                        onConfirm={async () => {
                          await handleDelete(productToDelete.id.toString());
                        } }
                        title="Delete Product"
                        content={`Are you sure you want to delete "${productToDelete.productName}"?`} />
                    )}
                  </Grid>
                </Card>


              </Grid> */}</>

      {/* )}   */}



{selectedCard === "Looping" && product?.productDetailsIsLooping == true && (


            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Card className={classes.stepperCard} sx={{ minHeight: "250px" }}>
                <Grid container spacing={1}>
                  <Grid item lg={12} md={12} sm={12} xs={12} pt={2}>
                    <Grid
                      container
                      justifyContent={"space-between"}
                      spacing={5}
                      sx={{ borderBottom: 2, padding: 2 }}
                      className={classes.titleGrid}
                    >
                      <Grid
                        item
                        lg={12}
                        md={12}
                        sm={12}
                        xs={12}
                        pt={2}
                        alignContent={"center"}
                      >
                        <Typography variant="subtitle1">
                          <span className={classes.customerDetails}>
                            Looping :
                          </span>{" "}
                          {product?.loopingDetails?.shortTableName}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>

                  {product?.productDetailsIsLooping && (
                    <Grid item lg={12} md={12} sm={12} xs={12} pt={2}>
                      <Card className={classes.stepperCard}>
                        <Grid
                          container
                          justifyContent={"space-between"}
                          spacing={2}
                          sx={{ padding: 2 }}
                          className={classes.titleGrid}
                        >
                          {product?.loopingDetails?.tableColumns.map(
                            (column, index) => (
                              <Grid
                                item
                                lg={12}
                                md={12}
                                sm={12}
                                xs={12}
                                pt={2}
                                alignContent={"center"}
                                key={index}
                                className={
                                  classes.productViewPageTableHeaderCell
                                }
                              >
                                <Typography>
                                  <span className={classes.customerDetails}>
                                    {column.name} :
                                  </span>{" "}
                                  {column.type === "boolean"
                                    ? column.value
                                      ? "True"
                                      : "False"
                                    : column.value}
                                </Typography>
                              </Grid>
                            )
                          )}
                        </Grid>
                      </Card>
                    </Grid>
                  )}
                </Grid>
              </Card>
            </Grid>
          )}

        
        </Grid>
      </Grid>


  <Dialog
    open={showModifierGrpPopup}
    onClose={() => setShowModifierGrpPopup(false)}
    maxWidth="sm"
    fullWidth
  >
     <DialogTitle>
    <Grid container alignItems="center" justifyContent="space-between" >
      <Grid item>
        Select Modifier Group
      </Grid>
      <Grid item>
        <TextField
          size="small"
          placeholder="Search..."
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
        />
      </Grid>
    </Grid>
  </DialogTitle>
    <DialogContent  sx={{
    minHeight: 300, // fixed height
    overflowY: "auto", // scroll if content exceeds
    pt: 1,
  }}>
      <FormGroup>
            {modifierGrpList.filter((group) =>
      group.modifierGroupName?.toLowerCase().includes(searchText.toLowerCase())
    ).length === 0 ? (
      <Typography align="center" >
        No data available
      </Typography>
    ) : (
         modifierGrpList.filter((group) =>
          group.modifierGroupName
            ?.toLowerCase()
            .includes(searchText.toLowerCase())
        ).map((group: IModifierGrpPopUp) => { 
          const isSelected = selectedModifierGrpIds.includes(String(group.id)); 
          const existing: IModifierGrpPopUp = modifierGrpDetails.find((g) => Number(g.id) === Number(group.id)) ||
           { id: group.id, minimum: "", maximum: "", }; 
           const minVal = existing.minimum || ""; 
           const maxVal = existing.maximum || "";   
          return ( <div key={group.id} style={{ marginBottom: "16px" }}>
         
      {/* <FormControlLabel control={ 
              <Checkbox checked={isSelected}
               onChange={(e) => { const idStr = String(group.id); if (e.target.checked) { 
                 const existing = modifierGrpDetails.find((g) => g.id === group.id) || selectedModifierGrps.find((g) => String(g.modifierGroupId) === String(group.id)) || { minimum: "", maximum: "" }; 
                 setSelectedModifierGrpIds([...selectedModifierGrpIds, idStr]); 
                 setModifierGrpDetails((prev) => [ ...prev.filter((g) => g.id !== group.id), { ...group, minimum: existing.minimum, maximum: existing.maximum} ]); } 
                 else { 
                  setSelectedModifierGrpIds(selectedModifierGrpIds.filter((id) => id !== idStr));
                   setModifierGrpDetails((prev) => prev.filter((g) => g.id !== group.id) );
                    } }} 
                    /> 
                    } 
                    label={group.modifierGroupName || "Unnamed Group"} />
           
              {isSelected && (
                <div style={{ paddingLeft: "32px", marginTop: "8px" }}>
                <TextField
  label="Minimum"
  type="number"
  size="small"
  value={modifierGrpDetails.find((g) => Number(g.id) === Number(group.id))?.minimum || ""}
  onChange={(e) => {
    const value = e.target.value;
    setModifierGrpDetails((prev) =>
      prev.map((g) =>
        Number(g.id) === Number(group.id)
          ? { ...g, minimum: value }
          : g
      )
    );
  }}
  style={{ width: "100px", marginRight: "12px" }}
/>

<TextField
  label="Maximum"
  type="number"
  size="small"
  value={modifierGrpDetails.find((g) => Number(g.id) === Number(group.id))?.maximum || ""}
  onChange={(e) => {
    const value = e.target.value;
    setModifierGrpDetails((prev) =>
      prev.map((g) =>
        Number(g.id) === Number(group.id)
          ? { ...g, maximum: value }
          : g
      )
    );
  }}
  style={{ width: "100px" }}
/>
 </div> 
                 )}  */}


<Grid
  container
  alignItems="center"
  spacing={2}
  sx={{ mb: 1 }}
>
  {/* Checkbox + Name */}
  <Grid item xs={isSelected ? 6 : 12} display="flex" alignItems="center">
    <Checkbox
      checked={isSelected}
      onChange={(e) => {
        const idStr = String(group.id);

        if (e.target.checked) {
          const existing =
            modifierGrpDetails.find((g) => g.id === group.id) ||
            { minimum: "", maximum: "" };

          setSelectedModifierGrpIds([...selectedModifierGrpIds, idStr]);
          setModifierGrpDetails((prev) => [
            ...prev.filter((g) => g.id !== group.id),
            { ...group, minimum: existing.minimum, maximum: existing.maximum },
          ]);
        } else {
          setSelectedModifierGrpIds(
            selectedModifierGrpIds.filter((id) => id !== idStr)
          );
          setModifierGrpDetails((prev) =>
            prev.filter((g) => g.id !== group.id)
          );
        }
      }}
    />
    <Typography>
      {group.modifierGroupName || "Unnamed Group"}
    </Typography>
  </Grid>

  {/* Min / Max ONLY when selected */}
  {isSelected && (
    <>
      <Grid item xs={3}>
        <TextField
          label="Min"
          type="number"
          size="small"
          value={
            modifierGrpDetails.find(
              (g) => Number(g.id) === Number(group.id)
            )?.minimum || ""
          }
          onChange={(e) => {
            const value = e.target.value;
            setModifierGrpDetails((prev) =>
              prev.map((g) =>
                Number(g.id) === Number(group.id)
                  ? { ...g, minimum: value }
                  : g
              )
            );
          }}
          fullWidth
        />
      </Grid>

      <Grid item xs={3}>
        <TextField
          label="Max"
          type="number"
          size="small"
          value={
            modifierGrpDetails.find(
              (g) => Number(g.id) === Number(group.id)
            )?.maximum || ""
          }
          onChange={(e) => {
            const value = e.target.value;
            setModifierGrpDetails((prev) =>
              prev.map((g) =>
                Number(g.id) === Number(group.id)
                  ? { ...g, maximum: value }
                  : g
              )
            );
          }}
          fullWidth
        />
      </Grid>
    </>
  )}
</Grid>






                 </div> 
                );
        })
    )}
      </FormGroup>
    </DialogContent>
  <DialogActions>

<Grid item lg={12} md={12} sm={12} xs={12} >
                    <Card className={classes.card}>
                      <Grid container spacing={3} p={"24px"}>
                        <Grid
                          item
                          lg={12}
                          md={12}
                          sm={12}
                          xs={12}
                          sx={{ display: "flex", justifyContent: "flex-end" }}
                        >
                          <Button
     variant="outlined"
    className={classes.addButton}
    color="primary"
     onClick={() => {
        // Apply selected modifier groups locally if needed
        const selectedGroups = modifierGrpList.filter((group) => selectedModifierGrpIds.includes(group.id));
        setModifierGrpDetails(selectedGroups);
        setShowModifierGrpPopup(false);
      }}
>
    
    Cancel </Button>
                          <Box m={0.5}></Box>

                         <Button
    variant="contained"
    className={classes.addButton}
    color="primary"
    onClick={handleSaveModifierGrps}
  >
    Save
  </Button>

                        </Grid>
                        </Grid>
                        </Card>
                        </Grid>
                        

   
   
  </DialogActions>
</Dialog>







    {/* <Dialog open={showModifierGroupPopup} onClose={() => setShowModifierGroupPopup(false)} maxWidth="md" fullWidth>
  <DialogTitle>Select Modifier Group</DialogTitle>
  <DialogContent >
  
  
  <FormControl fullWidth size="small" sx={{ mb: 2, mt: 2 }}>
<Autocomplete
  options={filteredModifierGroups}
  getOptionLabel={option => option.modifierGroupName ?? ''}
  value={
  modifierGroupList.find(group => Number(group.id) === selectedModifierGroupId) || null
}

  onChange={(event, newValue) => {
    if (newValue) {
      setSelectedModifierGroupId(Number(newValue.id));
      setModifierGroupDetails(newValue);
    } else {
      setSelectedModifierGroupId(null);
      setModifierGroupDetails(null);
    }
  }}

  renderInput={params => <TextField {...params} label="Select Modifier Group" size="small" />}
/>

</FormControl>

  
{modifierGroupDetails && (
  <>
<Grid container spacing={2} mt={1} mb={4}>
 <Grid item xs={6} md={3}>
  <TextField
    label="Minimum"
    type="number"
    size="small"
    fullWidth
    value={modifierGroupDetails.minimum ?? ''}
    onChange={(e) =>
      setModifierGroupDetails(prev =>
        prev
          ? {
              ...prev,
              minimum: e.target.value === '' ? 0 : parseInt(e.target.value, 10),
            }
          : prev
      )
    }
  />
</Grid>

<Grid item xs={6} md={3}>
  <TextField
    label="Maximum"
    type="number"
    size="small"
    fullWidth
    value={modifierGroupDetails.maximum ?? ''}
    onChange={(e) =>
      setModifierGroupDetails(prev =>
        prev
          ? {
              ...prev,
              maximum: e.target.value === '' ? 0 : parseInt(e.target.value, 10),
            }
          : prev
      )
    }
  />
</Grid>




      <Grid item xs={6} md={3}>
        <TextField
          label="Order No."
          type="number"
          size="small"
          fullWidth
          value={modifierGroupDetails.order ?? ''}
          onChange={(e) =>
            setModifierGroupDetails(prev => prev ? { ...prev, order: parseInt(e.target.value) || 0 } : prev)
          }
        />
      </Grid>

      <Grid item xs={6} md={3} display="flex" alignItems="center">
        <FormControlLabel
          control={
            <Switch
              checked={modifierGroupDetails.required ?? false}
              onChange={(e) =>
                setModifierGroupDetails(prev => prev ? { ...prev, required: e.target.checked } : prev)
              }
              color="primary"
            />
          }
          label="Required"
        />
      </Grid>
    </Grid>


    <Table className={classes.table} >
      <TableHead className={classes.tableHeaderRow}>
        <TableRow>
          <TableCell  className={classes.tablheader}> <strong>Modifier Name </strong></TableCell>
          <TableCell  className={classes.tablheader}> <strong>Overwrite</strong></TableCell>
          <TableCell  className={classes.tablheader}> <strong>Price</strong></TableCell>
        </TableRow>
      </TableHead>
     <TableBody>
    {(modifierGroupDetails.modifiers ?? []).map((mod, index) => {
      const modInfo = modifierList.find((m) => m.id === mod.modifier_id);
      const name = modInfo ? modInfo.modifierName : `ID: ${mod.modifier_id}`;

   const handleOverwriteChange = (e: React.ChangeEvent<HTMLInputElement>) => {
  const updated = [...(modifierGroupDetails.modifiers ?? [])];
  updated[index] = { ...updated[index], overwrite: e.target.checked }; // Ensure immutability
  if (!e.target.checked) {
    updated[index].overwrite_price = 0;
  }
  setModifierGroupDetails({ ...modifierGroupDetails, modifiers: updated });
};

const handlePriceChange = (e: React.ChangeEvent<HTMLInputElement>) => {
  const updated = [...(modifierGroupDetails.modifiers ?? [])];
  updated[index] = {
    ...updated[index],
    overwrite_price: parseFloat(e.target.value) || 0,
  };
  setModifierGroupDetails({ ...modifierGroupDetails, modifiers: updated });
};

      return (
        <TableRow key={index}>
          <TableCell className={classes.tablCell}>{name}</TableCell>
          <TableCell className={classes.tablCell}>
            <CustomCheckbox
              checked={mod.overwrite || false}
              onChange={handleOverwriteChange}
              color="primary"
            />
          </TableCell>
          <TableCell className={classes.tablCell}>
           <TextField
  type="number"
  value={mod.overwrite ? mod.overwrite_price ?? '' : ''}
  onChange={handlePriceChange}
  inputProps={{ step: "0.01", min: "0" }}
  size="small"
  disabled={!mod.overwrite}
  sx={{
    minWidth: '80px',
    backgroundColor: mod.overwrite ? 'transparent' : 'transparent',
    visibility: mod.overwrite ? 'visible' : 'hidden', // still takes space
  }}
/>

          </TableCell>
        </TableRow>
      );
    })}
  </TableBody>
    </Table>

    
  </>
)}

  </DialogContent>
  <DialogActions>
   


<Grid item lg={12} md={12} sm={12} xs={12} >
                    <Card className={classes.card}>
                      <Grid container spacing={3} p={"24px"}>
                        <Grid
                          item
                          lg={12}
                          md={12}
                          sm={12}
                          xs={12}
                          sx={{ display: "flex", justifyContent: "flex-end" }}
                        >
                          <Button
     variant="outlined"
    className={classes.addButton}
    color="primary"
    onClick={() => setShowModifierGroupPopup(false)}
  >Cancel </Button>
                          <Box m={0.5}></Box>

                         <Button
    variant="contained"
    className={classes.addButton}
    color="primary"
    onClick={handleSaveModifierGroups}
  >
    Save
  </Button>

                        </Grid>
                      </Grid>
                    </Card>
                  </Grid>

</DialogActions>
</Dialog>
 */}


 {/* <Dialog open={showLinkedProductPopup} onClose={() => setShowLinkedProductPopup(false)} maxWidth="md" fullWidth>
  <DialogTitle>Select Linked Products</DialogTitle>
  <DialogContent >
    <FormControl fullWidth size="small" sx={{ mb: 2, mt: 2 }}>
   <Autocomplete<IProduct>
      options={filteredProducts.filter(p => String(p.id) !== String(ProductId))}
    getOptionLabel={(option) => option.productName ?? ""}
   onChange={(event, newValue) => {
    console.log(ProductId, filteredProducts);
  if (newValue) {
    setLinkedProducts(prev => {
      const cleaned = prev.filter(p => p && typeof p === 'object');
      if (!cleaned.some(p => p.id === newValue.id)) {
        return [...cleaned, newValue];
      }
      return cleaned;
    });
  }
}}

    renderInput={(params) => <TextField {...params} label="Select Product" />}
  />
</FormControl>
  </DialogContent>
  <DialogActions>
   


<Grid item lg={12} md={12} sm={12} xs={12} >
                    <Card className={classes.card}>
                      <Grid container spacing={3} p={"24px"}>
                        <Grid
                          item
                          lg={12}
                          md={12}
                          sm={12}
                          xs={12}
                          sx={{ display: "flex", justifyContent: "flex-end" }}
                        >
                          <Button
     variant="outlined"
    className={classes.addButton}
    color="primary"
    onClick={() => setShowLinkedProductPopup(false)}
  >Cancel </Button>
                          <Box m={0.5}></Box>

                         <Button
    variant="contained"
    className={classes.addButton}
    color="primary"
    onClick={handleSaveLinkedProducts}
  >
    Save
  </Button>

                        </Grid>
                      </Grid>
                    </Card>
                  </Grid>

</DialogActions>
</Dialog> */}


<Popover
  open={Boolean(anchorEl)}
  anchorEl={anchorEl}
  onClose={() => setAnchorEl(null)}
  anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
>
  <MenuItem
    onClick={() => {
      setAnchorEl(null);
      setOpenPriceDialog(true);
    }}
  >
    Price
  </MenuItem>

  <MenuItem
    onClick={() => {
      applyBulkToggle("pos");
      setAnchorEl(null);
    }}
  >
    POS
  </MenuItem>

  <MenuItem
    onClick={() => {
      applyBulkToggle("online");
      setAnchorEl(null);
    }}
  >
    Online
  </MenuItem>
</Popover>


<Dialog open={openPriceDialog} onClose={() => setOpenPriceDialog(false)}>
  <DialogTitle>Update Price</DialogTitle>

  <DialogContent>
    <TextField
      label="Enter Price"
      type="number"
      fullWidth
      size="small"
      value={priceValue}
      onChange={(e) => setPriceValue(e.target.value)}
    />
  </DialogContent>

  <DialogActions>
    <Button onClick={() => setOpenPriceDialog(false)}>Cancel</Button>

    <Button variant="contained" onClick={applyPriceUpdate}>
      Apply
    </Button>
  </DialogActions>
</Dialog>



<Dialog
  open={showOrderPopup}
  onClose={() => setShowOrderPopup(false)}
  fullWidth
>

  <DialogTitle>Change Modifier Group Order</DialogTitle>

 <DialogContent style={{ maxHeight: 400, overflowY: "auto" }}>
    
    <div id="drag-container" style={{ position: "relative", zIndex: 99999 }}>
      <DragDropContext  onDragEnd={(result) => {
    if (!result.destination) return;
    const items = Array.from(orderList);
    const [reordered] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reordered);
    setOrderList(items);
  }}>
        <Droppable droppableId="modifierGroups">
          {(provided) => (
            <div ref={provided.innerRef} {...provided.droppableProps}>
              {orderList.map((grp, index) => (
                <Draggable key={grp.id} draggableId={String(grp.id)} index={index}>
                  {(provided) => (
                    <div
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                      style={{
                        padding: 10,
                        background: "#f0f0f0",
                        marginBottom: 8,
                        border: "1px solid #ccc",
                        ...provided.draggableProps.style
                      }}
                    >
                      {grp.modifierGroupName}
                    </div>
                  )}
                </Draggable>
              ))}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    </div>

  </DialogContent>

  <DialogActions>
      <Grid item lg={12} md={12} sm={12} xs={12} >
                    <Card className={classes.card}>
                         <Grid container spacing={3} p={"24px"}>
                        <Grid
                          item
                          lg={12}
                          md={12}
                          sm={12}
                          xs={12}
                          sx={{ display: "flex", justifyContent: "flex-end" }}
                        >
    <Button variant="outlined"
                        startIcon={<CloseIcon />}
                        className={classes.addButton} onClick={() => setShowOrderPopup(false)}>Cancel</Button>
         <Box m={0.5}></Box>             
 <Button
      variant="contained"
         className={classes.addButton} 
      onClick={() => {
   const updatedModifierGrps: ModifierGrpSelection[] = orderList.map((grp, index) => ({
  id: Number(grp.id ?? grp.modifierGroupId),      // MUST be number
  modifierGroupId: Number(grp.modifierGroupId ?? grp.id), 
  modifierGroupName: grp.modifierGroupName || "",
  minimum: grp.minimum ? Number(grp.minimum) : 0,
  maximum: grp.maximum ? Number(grp.maximum) : 0,
  order: index + 1,
  modifiers: grp.modifiers || []
}));

setSelectedModifierGrps(updatedModifierGrps);
updateModifierGrpOrder(updatedModifierGrps);
setShowOrderPopup(false);

      }}
    >
      Save Order
    </Button>
</Grid>
</Grid>
</Card></Grid>



  
  </DialogActions>
</Dialog>


<Dialog
  open={openSerialized}
  onClose={() => setOpenSerialized(false)}
  maxWidth="sm"
  fullWidth
>
  <DialogTitle>Serialized Item Details</DialogTitle>
  <DialogContent dividers>
    {selectedSerialized ? (
      <Grid container spacing={2}>
        {[
          { label: "Serial No", value: selectedSerialized.SERIALNO },
          { label: "IMEI No", value: selectedSerialized.IMEInO },
          { label: "Model No", value: selectedSerialized.modelNo },
          { label: "Buy Price", value: selectedSerialized.buyingPrice },
        {
  label: "Vendor",
  value: (
    
      <Link
      to={`/vendor-history/${selectedSerialized.vendorId}`}
      style={{
        textDecoration: "none",
        color: "inherit",
        cursor: "pointer",
      }}
    >
      <Box display="inline-flex" alignItems="center">
        <Typography
          sx={{
            // color: "#1976d2",
            // fontWeight: 600,
            cursor: "pointer",
          }}
        >
          {selectedSerialized.vendorName || "-"}
        </Typography>

        &nbsp;
        <LinkIcon fontSize="small" sx={{ color: "#1976d2" }} />
      </Box>
    </Link>
  )
},
 { label: "Bill No", value: selectedSerialized.billNo},
          { label: "Notes", value: selectedSerialized.notes },
        ].map((item, index) => (
          <Grid
            container
            item
            xs={12}
            spacing={1}
            key={index}
            sx={{
              borderBottom: index !== 6 ? "1px solid #e0e0e0" : "none",
              paddingY: 1,
              alignItems: "center",
            }}
          >
            <Grid item xs={5}>
              <Typography variant="subtitle2" color="textSecondary">
                {item.label}:
              </Typography>
            </Grid>
            <Grid item xs={7}>
              <Typography variant="body1">{item.value || "-"}</Typography>
            </Grid>
          </Grid>
        ))}
      </Grid>
    ) : (
      <Typography align="center" color="textSecondary">
        No stock details found for this item.
      </Typography>
    )}
  </DialogContent>
  <DialogActions>
    <Grid item lg={12} md={12} sm={12} xs={12} >
                    <Card className={classes.card}>
                         <Grid container spacing={3} p={"24px"}>
                        <Grid
                          item
                          lg={12}
                          md={12}
                          sm={12}
                          xs={12}
                          sx={{ display: "flex", justifyContent: "flex-end" }}
                        >
    <Button variant="contained" color="primary" onClick={() => setOpenSerialized(false)}>
      Close
    </Button>
    </Grid>
    </Grid>
    </Card>
    </Grid>
  </DialogActions>
</Dialog>


<Dialog open={open} onClose={() => setOpen(false)}>
        <DialogTitle>Edit Price</DialogTitle>
        <DialogContent>
          <TextField
            label="Reg Price"
            type="number"
            fullWidth
            margin="dense"
            value={regPrice}
            onChange={(e) => setRegPrice(Number(e.target.value))}
          />
          <TextField
            label="Sale Price"
            type="number"
            fullWidth
            margin="dense"
            value={salePrice}
            onChange={(e) => setSalePrice(Number(e.target.value))}
          />
        </DialogContent>
       <DialogActions>
        <Grid item lg={12} md={12} sm={12} xs={12} >
                    <Card className={classes.card}>
                         <Grid container spacing={3} p={"24px"}>
                        <Grid
                          item
                          lg={12}
                          md={12}
                          sm={12}
                          xs={12}
                          sx={{ display: "flex", justifyContent: "flex-end" }}
                        >
    <Button variant="outlined" color="primary"  className={classes.addButton} onClick={() => setOpen(false)}>
      Cancel
    </Button>
       <Box m={0.5}></Box>
      <Button onClick={handleSave}  className={classes.addButton} variant="contained">Save</Button>
    </Grid>
    </Grid>
    </Card>
    </Grid>
         
        
        </DialogActions>
      </Dialog>



<Dialog open={openManualModal} onClose={() => setOpenManualModal(false)} maxWidth="xs" fullWidth>
  <DialogTitle>Manual Stock Adjustment</DialogTitle>

  <DialogContent>

 <FormControl fullWidth margin="dense">
      <InputLabel>Adjustment Type</InputLabel>
      <Select
        value={adjustType}
        label="Adjustment Type"
        onChange={(e) => setAdjustType(e.target.value as any)}
      >
        <MenuItem value="add">Add Stock</MenuItem>
        <MenuItem value="deduct">Deduct Stock</MenuItem>
      </Select>
    </FormControl>

    <TextField
      label="Quantity"
      type="number"
      fullWidth
      margin="dense"
      value={manualQty}
      inputProps={{ min: 1 }}
      onChange={(e) => setManualQty(e.target.value)}
     // helperText="Use + for add, - for deduct"
    />

    <TextField
      label="Remarks"
      rows={3}
      multiline
      fullWidth
      margin="dense"
      value={manualReason}
      onChange={(e) => setManualReason(e.target.value)}
    />
  </DialogContent>

  <DialogActions>
       <Grid item lg={12} md={12} sm={12} xs={12} >
                    <Card className={classes.card}>
                         <Grid container spacing={3} p={"24px"}>
                        <Grid
                          item
                          lg={12}
                          md={12}
                          sm={12}
                          xs={12}
                          sx={{ display: "flex", justifyContent: "flex-end" }}
                        >
    <Button variant="outlined" color="primary"  className={classes.addButton} onClick={() => setOpenManualModal(false)}>Cancel</Button>
     <Box m={0.5}></Box>
    <Button
     className={classes.addButton} variant="contained"
      onClick={handleManualStockSubmit}
      disabled={loading}
    >
      Save
    </Button>
    </Grid>
    </Grid>
    </Card>
    </Grid>
  </DialogActions>
</Dialog>

<Menu
  anchorEl={menuAnchor}
  open={Boolean(menuAnchor)}
  onClose={handleMenuClose}
>
  {/* <MenuItem onClick={() => handleAction("sold")}>
    Mark as Sold
  </MenuItem> */}
  <MenuItem onClick={() => handleAction("out_of_stock")}>
    Out of Stock
  </MenuItem>
</Menu>

<Dialog open={openRemarkDialog} onClose={closeRemarkDialog} maxWidth="xs" fullWidth>
  <DialogTitle>Update Serial Status</DialogTitle>

  <DialogContent>
    <Typography variant="body2" mb={1}>
      Status: <b>{selectedStatus}</b>
    </Typography>

    <TextField
      label="Remarks"
      multiline
      rows={3}
      fullWidth
      value={remarks}
      onChange={(e) => setRemarks(e.target.value)}
      placeholder="Enter reason / remarks"
      required
    />
  </DialogContent>

  <DialogActions>
       <Grid item lg={12} md={12} sm={12} xs={12} >
                    <Card className={classes.card}>
                         <Grid container spacing={3} p={"24px"}>
                        <Grid
                          item
                          lg={12}
                          md={12}
                          sm={12}
                          xs={12}
                          sx={{ display: "flex", justifyContent: "flex-end" }}
                        >
    <Button variant="outlined" color="primary"  className={classes.addButton}
    onClick={closeRemarkDialog}>Cancel</Button>
     <Box m={0.5}></Box>
    <Button
      variant="contained" color="primary"  className={classes.addButton}
      disabled={!remarks.trim()}
      onClick={handleConfirmStatusUpdate}
    >
      Save
    </Button>
     </Grid>
    </Grid>
    </Card>
    </Grid>
  </DialogActions>
</Dialog>




    </Grid>








  );
};

export default Index;
